import { SetupContext } from '@vue/composition-api'
import { handleShapeBilling } from '@/lib/sessionStrage/re-billing-utils'
import apiConnect from '@/lib/api-connect'
import apiStatus from '@/lib/api-status'
import { BillingCldInfo, BillingCldTableItemInfo, cldInfo } from 'src/@types/children/index'
import moment from 'moment'
import {
  ubItem,
  upperLimitState,
  upperLimitVuexState,
} from '@/@types/billing/upperLimit/index'
import {
  handleIsbeneficiaryIdView,
  childAllAdditionItemArray,
} from '@/lib/children/utils'
import localStorageUtils from '@/lib/localStorage/local-storage-utils'
import sessionStorageUtils from '@/lib/sessionStrage/session-strage-utils'
import format from '@/lib/formatUtils/format'
import BigNumber from 'bignumber.js'
import {
  CustomBillingDetailsType,
  DetailsItemType,
  DetailsState,
  ServiceType,
  SummaryType,
  SummaryTotalType,
  DetailsVuexState,
} from '@/@types/billing/details'
import { defineObject } from '@/lib/define/use-define'
import {
  ResponseAchievementsType,
  ResponseVisitAchievementsType,
} from '@/@types/achievements'
import {
  BillingPostParamType,
  ChildOfficeUnitsBillingGroupType,
  ServiceCodeTypeAndAffiliationType,
} from '@/@types/billing/utility/index'
import { OfficeInfo } from '@/@types/office'

import { updateAchievementsAndGetTargetCldBookCnt, updateNewAchievementsAndGetTargetCldBookCnt } from '@/lib/api/use-get-data'

import { handleGetWaitingTime } from '@/lib/achievements/utils'

import { difference } from 'underscore'

import { useBasicCalcAddition } from '@/store/modules/claim_country/useBasicCalcAddition'

import { deleteBulkServiceAndDetailsAndSummary } from '@/lib/billing/details'

export const handleIsDetailsSummaryServiceCodeTypeInTargetAffiliation = (
  targetAffiliation: string,
  targetDetails: DetailsState | undefined
) => {
  let res = false

  const targetServiceCodeTypeAndAffiliationItem = defineObject.SERVICE_CODE_TYPE_AND_AFFILIATION_ARRAY.find(
    (serviceCodeTypeAndAffiliationItem: ServiceCodeTypeAndAffiliationType) =>
      serviceCodeTypeAndAffiliationItem.affiliation === targetAffiliation
  )

  if (
    targetServiceCodeTypeAndAffiliationItem &&
    targetDetails &&
    Array.isArray(targetDetails.summary) &&
    targetDetails.summary.some(
      (summaryItem: SummaryType) =>
        summaryItem.batServiceCodeType ===
        targetServiceCodeTypeAndAffiliationItem.serviceCodeType
    )
  ) {
    res = true
  }

  return res
}

export const handleGetAffiliationDetails = (details: DetailsState) => {
  const billingAffiliationArray = []

  for (
    let index = 0;
    index < defineObject.SERVICE_CODE_TYPE_AND_AFFILIATION_ARRAY.length;
    index++
  ) {
    if (
      handleIsDetailsSummaryServiceCodeTypeInTargetAffiliation(
        defineObject.SERVICE_CODE_TYPE_AND_AFFILIATION_ARRAY[index].affiliation,
        details
      )
    ) {
      billingAffiliationArray.push(
        defineObject.SERVICE_CODE_TYPE_AND_AFFILIATION_ARRAY[index]
      )
    }
  }

  const targetBillingNormalAffiliationArray = billingAffiliationArray.filter(
    (targetBillingAffiliation: { affiliation: string }) =>
      targetBillingAffiliation.affiliation === '0' ||
      targetBillingAffiliation.affiliation === '1'
  )

  const targetBillingVisitAffiliationArray = billingAffiliationArray.filter(
    (targetBillingAffiliation: { affiliation: string }) =>
      targetBillingAffiliation.affiliation === '2'
  )

  const targetBillingAffiliationArray = ([] as {
    affiliation: string
  }[]).concat(
    targetBillingNormalAffiliationArray,
    targetBillingVisitAffiliationArray
  )

  return targetBillingAffiliationArray
}

// 計算ロジック 給付費明細欄 - サービス単位数
// フロントによる計算・「単位数」×「回数」
export const handleBeUnitsSet = (details: DetailsState) => {
  for (let index = 0; index < details.details.length; index++) {
    if (
      details.details[index].beServiceCode !== '' &&
      details.details[index].beUnits !== '' &&
      details.details[index].beCount !== ''
    ) {
      details.details[index].beServiceUnits = 0
      details.details[index].beServiceUnits =
        Number(details.details[index].beUnits) *
        Number(details.details[index].beCount)
    } else {
      details.details[index].beServiceUnits = ''
    }
  }
}

const {
  valueCovidZZ01CalculationSet,
  valueSubtractionZ001CalculationSet,
} = useBasicCalcAddition()

export const handleErrReset = (context: SetupContext) => {
  context.root.$store.commit('childrenValid/valueErrSet', {
    details: {
      details: [],
    },
    upperLimit: {
      ub: [],
    },
  })
}

export const handleIsDetailsCombined = (
  targetDetails: DetailsState | undefined
) => {
  let res = false

  if (
    targetDetails &&
    Array.isArray(targetDetails.summary) &&
    targetDetails.summary.length > 1
  ) {
    res = true
  }

  return res
}

export const handleIsAchivementsByCldId = (
  cldId: string,
  achievementsArray: ResponseAchievementsType[]
) => {
  let res = false
  if (
    achievementsArray.some(
      (achievements: ResponseAchievementsType) => achievements.cld_id === cldId
    )
  ) {
    res = true
  }

  return res
}

export const handleIsVisitAchivementsByCldId = (
  cldId: string,
  visitAchievementsArray: ResponseVisitAchievementsType[]
) => {
  let res = false

  if (
    visitAchievementsArray.some(
      (achievements: ResponseVisitAchievementsType) =>
        achievements.cld_id === cldId
    )
  ) {
    res = true
  }

  return res
}

export const handleIsOtherOfficeAchivementsByCldId = (
  cldId: string,
  achievementsArray: ResponseAchievementsType[],
  childBillingGroupArray: ChildOfficeUnitsBillingGroupType[]
) => {
  let res = false

  const targetChildBillingGroupArray = childBillingGroupArray.filter(
    (childBillingGroup: ChildOfficeUnitsBillingGroupType) =>
      childBillingGroup.cld_id === cldId
  )

  const targetLinkedCldIdArray = Array.from(
    new Set(
      targetChildBillingGroupArray.map(
        (childBillingGroup: ChildOfficeUnitsBillingGroupType) =>
          childBillingGroup.linked_cld_id
      )
    )
  )

  const targetAchievementsArray: ResponseAchievementsType[] = []

  targetLinkedCldIdArray.forEach((linkedCldId: string) => {
    const targetAchievementsArrayByLinkedCldId = achievementsArray.filter(
      (achievements: ResponseAchievementsType) =>
        achievements.cld_id === linkedCldId
    )

    targetAchievementsArray.push(...targetAchievementsArrayByLinkedCldId)
  })

  if (targetAchievementsArray.length !== 0) {
    res = true
  }

  return res
}

export const handleIsOtherOfficeVisitAchivementsByCldId = (
  cldId: string,
  visitAchievementsArray: ResponseVisitAchievementsType[],
  childBillingGroupArray: ChildOfficeUnitsBillingGroupType[]
) => {
  let res = false

  const targetChildBillingGroupArray = childBillingGroupArray.filter(
    (childBillingGroup: ChildOfficeUnitsBillingGroupType) =>
      childBillingGroup.cld_id === cldId
  )

  const targetLinkedCldIdArray = Array.from(
    new Set(
      targetChildBillingGroupArray.map(
        (childBillingGroup: ChildOfficeUnitsBillingGroupType) =>
          childBillingGroup.linked_cld_id
      )
    )
  )

  const targetVisitAchievementsArray: ResponseVisitAchievementsType[] = []

  targetLinkedCldIdArray.forEach((linkedCldId: string) => {
    const targetVisitAchievementsArrayByLinkedCldId = visitAchievementsArray.filter(
      (achievements: ResponseVisitAchievementsType) =>
        achievements.cld_id === linkedCldId
    )

    targetVisitAchievementsArray.push(
      ...targetVisitAchievementsArrayByLinkedCldId
    )
  })

  if (targetVisitAchievementsArray.length !== 0) {
    res = true
  }

  return res
}

export const handleIsDiffCldObjAffiliationAndOfficeAffiliation = (
  officeData: OfficeInfo,
  cldInfo: BillingCldInfo
) => {
  let res = false

  if (
    !officeData.affiliation.some(
      (officeAffiliation: string) => officeAffiliation === cldInfo.affiliation
    ) ||
    (cldInfo.visitChildFlg === '1' &&
      !officeData.affiliation.some(
        (officeAffiliation: string) => officeAffiliation === '2'
      ))
  ) {
    res = true
  }

  return res
}

export const handleIsAchivementsCombined = (
  cldId: string,
  achievementsArray: ResponseAchievementsType[],
  visitAchievementsArray: ResponseVisitAchievementsType[],
  childBillingGroupArray: ChildOfficeUnitsBillingGroupType[]
) => {
  let res = false

  if (
    (handleIsAchivementsByCldId(cldId, achievementsArray) &&
      handleIsVisitAchivementsByCldId(cldId, visitAchievementsArray)) ||
    (handleIsOtherOfficeAchivementsByCldId(
      cldId,
      achievementsArray,
      childBillingGroupArray
    ) &&
      handleIsOtherOfficeVisitAchivementsByCldId(
        cldId,
        visitAchievementsArray,
        childBillingGroupArray
      )) ||
    (handleIsAchivementsByCldId(cldId, achievementsArray) &&
      handleIsOtherOfficeVisitAchivementsByCldId(
        cldId,
        visitAchievementsArray,
        childBillingGroupArray
      )) ||
    (handleIsVisitAchivementsByCldId(cldId, visitAchievementsArray) &&
      handleIsOtherOfficeAchivementsByCldId(
        cldId,
        achievementsArray,
        childBillingGroupArray
      ))
  ) {
    res = true
  }
  return res
}

export const handleIsCldCombined = (billingCldInfo: BillingCldInfo) => {
  let res = false

  if (
    billingCldInfo.affiliation !== '2' &&
    billingCldInfo.visitChildFlg === '1'
  ) {
    res = true
  }

  return res
}

export const handleJapaneseCalendar = (date: Date) => {
  const currentDate = date
  const options: { [key: string]: string } = {
    era: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  const japaneseDate = new Intl.DateTimeFormat(
    'ja-JP-u-ca-japanese',
    options
  ).format(currentDate)
  return `${japaneseDate}`
}

export const useSelectValue = <
  T extends {
    modal: boolean
    confirmModal: boolean
    tabs: number
    officeName: string
    cldLastName: string
    cldFirstName: string
    componentTypes: any[]
  }
>(
  state: T
) => {
  const handleOpenDeleteModal = () => {
    state.modal = true
  }

  const handleCloseDeleteModal = () => {
    state.modal = false
    state.confirmModal = false
  }

  const handleTabSwitch = (index: number) => {
    state.tabs = index
  }

  const handlePrint = () => {
    const prevHtmlTitle = document.title

    const componentTypesObj = state.componentTypes[state.tabs]

    const titleArray = [
      componentTypesObj.pageTitle,
      // 事業所名
      state.officeName,
      // 児童名
      `${state.cldLastName} ${state.cldFirstName} さん`,
    ]
    const titleString = titleArray.join(' | ')
    document.title = titleString

    window.print()

    document.title = prevHtmlTitle
  }

  return {
    handlePrint,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleTabSwitch,
  }
}

export const handleIsVariableServiceCode = (beServiceCode: string) => {
  let res = false

  const checkBeServiceCode = beServiceCode.slice(2)

  if (
    defineObject.VARIABLE_SERVICE_CODE.find(
      (variableServiceCode: string) =>
        variableServiceCode === checkBeServiceCode
    )
  ) {
    res = true
  }

  return res
}

export const handleFilterSummaryArray = (stateDetailsData: DetailsState) => {
  const summaryArray = stateDetailsData.summary

  const detailsArray = stateDetailsData.details

  stateDetailsData.summary = summaryArray.filter((summaryItem: SummaryType) =>
    detailsArray.some(
      (detailsItem: DetailsItemType) =>
        summaryItem.batServiceCodeType === detailsItem.beServiceCode.slice(0, 2)
    )
  )
}

export const handleFilterServiceArray = (stateDetailsData: DetailsState) => {
  const serviceArray = stateDetailsData.service

  const detailsArray = stateDetailsData.details

  stateDetailsData.service = serviceArray.filter((serviceItem: ServiceType) =>
    detailsArray.some(
      (detailsItem: DetailsItemType) =>
        serviceItem.serviceCodeType === detailsItem.beServiceCode.slice(0, 2)
    )
  )
}

export const handleFilterByInServiceCode = (stateDetailsData: DetailsState) => {
  handleFilterServiceArray(stateDetailsData)
  handleFilterSummaryArray(stateDetailsData)
}

export const useValid = (context: SetupContext) => {
  const handleFindErr = (data: any) => {
    const res = Object.keys(data).some(key => {
      if (
        (data[key] && typeof data[key] === 'object') ||
        Array.isArray(data[key])
      ) {
        return handleFindErr(data[key])
      } else {
        if (data[key]) {
          return true
        }
      }
    })

    return res
  }

  const handleCheckResultCostAndUpperLimitOwnUbOfficeNumberMaster = (data: {
    upperLimit: upperLimitState
    details: any
  }) => {
    const errAllObj: any = {}
    errAllObj['ub'] = []

    // 自社の情報を取得する
    const targetUbArray = data.upperLimit.ub.filter(
      (ubItem: ubItem) =>
        String(ubItem.ubOfficeNumber) === String(data.upperLimit.officeNumber)
    )

    let targetUb: ubItem | undefined = targetUbArray[0]

    // きょうだい上限管理の場合は児童番号が1の自社情報を取得する
    if (targetUbArray.length > 1) {
      targetUb = data.upperLimit.ub.find(
        (ubItem: ubItem) =>
          String(ubItem.ubOfficeNumber) ===
            String(data.upperLimit.officeNumber) &&
          ubItem.ubCldUpperLimitNumber === 1
      )
    }

    if (
      Number(targetUb?.ubAfterCost) !== Number(data.details.resultCost) ||
      data.details.resultCost === '' ||
      targetUb?.ubAfterCost === ''
    ) {
      const errObj: any = {}

      errObj['ubOfficeNumber'] = true

      errAllObj['ub'][0] = errObj
    }

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'upperLimit',
      value: errAllObj,
    })
    return handleFindErr(errAllObj)
  }

  const handleCheckValidOnlyOwnUbOfficeNumber = (data: any) => {
    const errAllObj: any = {}
    // 上限管理が自社のみしかない
    errAllObj['ub'] = []

    const ubOfficeNumberArray: string[] = data.upperLimit[
      'ub'
    ].map((ubItem: any) => String(ubItem.ubOfficeNumber))

    if (
      ubOfficeNumberArray.every(
        (ubOfficeNumber: string) => ubOfficeNumberArray[0] === ubOfficeNumber
      )
    ) {
      for (let index = 0; index < data.upperLimit['ub'].length; index++) {
        const errObj: any = {}

        errObj['ubOfficeNumber'] = true

        errAllObj['ub'][index] = errObj
      }
    }

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'upperLimit',
      value: errAllObj,
    })
    return handleFindErr(errAllObj)
  }

  const handleCheckValidDuplicateUbCldUpperLimitNumberAndUbOfficeNumber = (
    data: any
  ) => {
    const errAllObj: any = {}
    // 空チェック[上限管理>総費用額/利用者負担額/管理結果後利用者負担額]
    errAllObj['ub'] = []
    for (let index = 0; index < data.upperLimit['ub'].length; index++) {
      if (
        data.upperLimit['ub'].filter(
          (checkUbItem: any) =>
            checkUbItem.ubCldUpperLimitNumber ===
              data.upperLimit['ub'][index].ubCldUpperLimitNumber &&
            checkUbItem.ubOfficeNumber ===
              data.upperLimit['ub'][index].ubOfficeNumber
        ).length > 1
      ) {
        const errObj: any = {}
        errObj['ubCldUpperLimitNumber'] = true
        errObj['ubOfficeNumber'] = true
        if (Object.keys(errObj).length !== 0) {
          errAllObj['ub'][index] = errObj
        }
      }
    }
    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'upperLimit',
      value: errAllObj,
    })
    return handleFindErr(errAllObj)
  }

  const handleCheckValidUpperLimitBrotherArray = (data: any) => {
    const emptyCheckArray = ['ub']

    const errAllObj: any = {}

    const checkBrotherArray = data.upperLimit.brotherArray.map(
      (cld: any) => cld.ubCldUpperLimitNumber
    )

    emptyCheckArray.forEach(key => {
      if (key === 'ub') {
        // 児童番号の存在チェック[上限管理 | 総費用額/利用者負担額/管理結果後利用者負担額]
        errAllObj[key] = []

        const viewUpperLimitCnt = 9

        if (
          !checkBrotherArray.every((ubCldUpperLimitNumber: number) =>
            data.upperLimit[key].some(
              (cld: any) => cld.ubCldUpperLimitNumber === ubCldUpperLimitNumber
            )
          )
        ) {
          for (let index = 0; index < viewUpperLimitCnt; index++) {
            const errObj: any = {}

            errObj.ubCldUpperLimitNumber = true

            if (Object.keys(errObj).length !== 0) {
              errAllObj[key][index] = errObj
            }
          }
        }
      }
    })

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'upperLimit',
      value: errAllObj,
    })

    return handleFindErr(errAllObj)
  }

  const handleCheckValidUpperLimit = (data: any) => {
    const emptyCheckArray = ['ub']

    const errAllObj: any = {}

    emptyCheckArray.forEach(key => {
      if (key === 'ub') {
        // 空チェック[上限管理>総費用額/利用者負担額/管理結果後利用者負担額]
        errAllObj[key] = []

        for (let index = 0; index < data.upperLimit[key].length; index++) {
          if (
            Object.keys(data.upperLimit[key][index]).some(
              (subkey: string) =>
                data.upperLimit[key][index][subkey] ||
                data.upperLimit[key][index][subkey] === 0
            )
          ) {
            const errObj: any = {}

            Object.keys(data.upperLimit[key][index]).forEach(
              (subkey: string) => {
                if (
                  subkey !== 'ubOfficeName' &&
                  subkey !== 'ubCldUpperLimitNumber' &&
                  subkey !== 'ubBeneficiaryId' &&
                  data.upperLimit[key][index][subkey] === ''
                ) {
                  errObj[subkey] = true
                }
              }
            )

            if (Object.keys(errObj).length !== 0) {
              errAllObj[key][index] = errObj
            }
          }
        }
      }

      // 空チェック[上限管理>利用者負担上限額管理結果]
      if (data.upperLimit[key] === '') {
        errAllObj[key] = true
      }
    })

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'upperLimit',
      value: errAllObj,
    })

    return handleFindErr(errAllObj)
  }

  const handleCheckValidBrotherUpperLimit = (data: any) => {
    const emptyCheckArray = ['ub']

    const errAllObj: any = {}

    emptyCheckArray.forEach(key => {
      if (key === 'ub') {
        // 空チェック[上限管理>総費用額/利用者負担額/管理結果後利用者負担額]
        errAllObj[key] = []

        for (let index = 0; index < data.upperLimit[key].length; index++) {
          if (
            Object.keys(data.upperLimit[key][index]).some(
              (subkey: string) =>
                data.upperLimit[key][index][subkey] ||
                data.upperLimit[key][index][subkey] === 0
            )
          ) {
            const errObj: any = {}

            Object.keys(data.upperLimit[key][index]).forEach(
              (subkey: string) => {
                if (
                  subkey !== 'ubOfficeName' &&
                  data.upperLimit[key][index][subkey] === ''
                ) {
                  errObj[subkey] = true
                } else if (
                  subkey === 'ubOfficeName' &&
                  (data.upperLimit[key][index][subkey] === '' ||
                    !String(data.upperLimit[key][index][subkey]).match(/\S/g))
                ) {
                  errObj[subkey] = true
                }
              }
            )

            if (Object.keys(errObj).length !== 0) {
              errAllObj[key][index] = errObj
            }
          }
        }
      }
    })

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'upperLimit',
      value: errAllObj,
    })

    return handleFindErr(errAllObj)
  }

  const handleCheckValidDetails = (data: any) => {
    const emptyCheckArray = [
      'details',
      'saDailyAmount',
      'saDay',
      'saBeBillingCost',
      'saActualCost',
      'summary',
    ]

    const errAllObj: any = {}

    emptyCheckArray.forEach(key => {
      if (key === 'details') {
        const detailsCheckKeyArray = [
          'beServiceContents',
          'beServiceCode',
          'beUnits',
          'beCount',
        ]

        errAllObj[key] = []
        // 空チェック[様式第二>給付費明細欄]
        for (let index = 0; index < data.details[key].length; index++) {
          if (
            Object.keys(data.details[key][index]).some(
              (subkey: string) =>
                data.details[key][index][subkey] ||
                data.details[key][index][subkey] === 0
            )
          ) {
            const errObj: any = {}

            Object.keys(data.details[key][index]).forEach((subkey: string) => {
              if (
                detailsCheckKeyArray.includes(subkey) &&
                data.details[key][index][subkey] === ''
              ) {
                errObj[subkey] = true
              }
            })

            if (Object.keys(errObj).length !== 0) {
              errAllObj[key][index] = errObj
            }
          }
        }

        // 給付費明細欄は最低1件は必要
        if (
          data.details[key].every((subData: any) =>
            Object.keys(subData).every(
              (subkey: string) => subData[subkey] === ''
            )
          )
        ) {
          const errObj: any = {}

          Object.keys(data.details[key][0]).forEach((subkey: string) => {
            if (detailsCheckKeyArray.includes(subkey)) {
              errObj[subkey] = true
            }
          })

          errAllObj[key][0] = errObj
        }
      }
    })

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'details',
      value: errAllObj,
    })

    return handleFindErr(errAllObj)
  }

  const handleCheckValidDetailsOnly = (data: any) => {
    const emptyCheckArray = ['details']

    const errAllObj: any = {}

    emptyCheckArray.forEach(key => {
      if (key === 'details') {
        const detailsCheckKeyArray = ['beServiceCode', 'beUnits', 'beCount']

        errAllObj[key] = []
        // 空チェック[様式第二>給付費明細欄]
        for (let index = 0; index < data.details[key].length; index++) {
          if (
            Object.keys(data.details[key][index]).some(
              (subkey: string) =>
                data.details[key][index][subkey] ||
                data.details[key][index][subkey] === 0
            )
          ) {
            const errObj: any = {}

            Object.keys(data.details[key][index]).forEach((subkey: string) => {
              if (
                detailsCheckKeyArray.includes(subkey) &&
                data.details[key][index][subkey] === ''
              ) {
                errObj[subkey] = true
              }
            })

            if (Object.keys(errObj).length !== 0) {
              errAllObj[key][index] = errObj
            }
          }
        }

        // 給付費明細欄は最低1件は必要
        if (
          data.details[key].every((subData: any) =>
            Object.keys(subData).every(
              (subkey: string) => subData[subkey] === ''
            )
          )
        ) {
          const errObj: any = {}

          Object.keys(data.details[key][0]).forEach((subkey: string) => {
            if (detailsCheckKeyArray.includes(subkey)) {
              errObj[subkey] = true
            }
          })

          errAllObj[key][0] = errObj
        }
      }
    })

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'details',
      value: errAllObj,
    })

    return handleFindErr(errAllObj)
  }

  const handleCheckValidCnt = (data: any) => {
    const errAllObj: any = {}

    errAllObj.details = []

    // 桁数チェック[様式第二>給付費明細欄>サービス単位数]
    for (let index = 0; index < data.details.details.length; index++) {
      if (String(data.details.details[index].beServiceUnits).length > 5) {
        const errObj: any = {}
        Object.keys(data.details.details[index]).forEach((subkey: string) => {
          if (subkey !== 'beDescription') {
            errObj[subkey] = true
          }
        })

        if (Object.keys(errObj).length !== 0) {
          errAllObj.details[index] = errObj
        }
      }
    }

    // 桁数チェック[請求額集計欄](計算結果がマイナスになる場合もエラー)
    const summaryCheckKeyArray = [
      'batBeUnits',
      'batTotalCost',
      'batEquivalentAmount',
      'batUbCost',
      'batUpperLimitMontylyAmount',
      'batAfterCost',
      'batAfterUpperLimitCost',
      'batDecisionUbCost',
      'batBillingAmount',
      'batBillingGrantMunicipal',
    ]

    const detailsCheckKeyArray = [
      'beServiceContents',
      'beServiceCode',
      'beUnits',
      'beCount',
    ]

    for (let index = 0; index < data.details.summary.length; index++) {
      if (
        Object.keys(data.details.summary[index]).some(
          (key: string) =>
            summaryCheckKeyArray.includes(key) &&
            (String(data.details.summary[index][key]).length > 6 ||
              data.details.summary[index][key] < 0)
        )
      ) {
        for (let index = 0; index < data.details.details.length; index++) {
          const errObj: any = {}
          Object.keys(data.details.details[index]).forEach((subkey: string) => {
            if (
              detailsCheckKeyArray.includes(subkey) &&
              data.details.details[index] &&
              data.details.summary[index] &&
              String(data.details.details[index].beServiceCode).slice(0, 2) ===
                String(data.details.summary[index].batServiceCodeType)
            ) {
              errObj[subkey] = true
            }
          })

          if (Object.keys(errObj).length !== 0) {
            errAllObj.details[index] = errObj
          }
        }

        errAllObj.resultCost = true
      }
    }

    // 桁数チェック[請求額集計欄>合計](計算結果がマイナスになる場合もエラー)
    Object.keys(data.details.summaryTotal).forEach(key => {
      if (
        String(data.details.summaryTotal[key]).length > 6 ||
        data.details.summaryTotal[key] < 0
      ) {
        for (let index = 0; index < data.details.details.length; index++) {
          const errObj: any = {}
          Object.keys(data.details.details[index]).forEach((subkey: string) => {
            if (
              subkey !== 'beDescription' &&
              data.details.details[index].beServiceUnits !== 0 &&
              data.details.details[index].beServiceUnits
            ) {
              errObj[subkey] = true
            }
          })

          if (Object.keys(errObj).length !== 0) {
            errAllObj.details[index] = errObj
          }
        }
        errAllObj.resultCost = true
      }
    })

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'details',
      value: errAllObj,
    })

    return handleFindErr(errAllObj)
  }

  const handleCheckValidRowCnt = (data: any) => {
    const errAllObj: any = {}

    errAllObj.details = []

    // 桁数チェック[様式第二>給付費明細欄>サービス単位数]
    for (let index = 0; index < data.details.details.length; index++) {
      if (String(data.details.details[index].beServiceUnits).length > 5) {
        const errObj: any = {}
        Object.keys(data.details.details[index]).forEach((subkey: string) => {
          if (subkey !== 'beDescription') {
            errObj[subkey] = true
          }
        })

        if (Object.keys(errObj).length !== 0) {
          errAllObj.details[index] = errObj
        }
      }
    }

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'details',
      value: errAllObj,
    })

    return handleFindErr(errAllObj)
  }

  const handleCheckValidServiceCodeTypeAndServiceCodeCheckRes = (data: any) => {
    const errAllObj: any = {}

    errAllObj.details = []

    for (let index = 0; index < data.details.details.length; index++) {
      if (
        data.details.details[index] &&
        (data.details.details[index].beServiceCode ||
          data.details.details[index].beServiceCode === 0)
      ) {
        const errObj: any = {}

        const beServiceCodeType = data.details.details[
          index
        ].beServiceCode.slice(0, 2)

        if (
          !data.details.summary.some(
            (summaryItem: SummaryType) =>
              summaryItem.batServiceCodeType === beServiceCodeType
          )
        ) {
          errObj.beServiceCode = true
        }

        if (Object.keys(errObj).length !== 0) {
          errAllObj.details[index] = errObj
        }
      }
    }

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'details',
      value: errAllObj,
    })

    return handleFindErr(errAllObj)
  }

  const handleCheckValidDuplicateServiceCodeCheckRes = (data: any) => {
    const errAllObj: any = {}

    errAllObj.details = []

    for (let index = 0; index < data.details.details.length; index++) {
      if (
        data.details.details[index] &&
        (data.details.details[index].beServiceCode ||
          data.details.details[index].beServiceCode === 0)
      ) {
        const errObj: any = {}
        const filterTarget = data.details.details.filter(
          (subData: any) =>
            String(subData.beServiceCode) ===
            String(data.details.details[index].beServiceCode)
        )

        if (filterTarget && filterTarget.length > 1) {
          errObj.beServiceCode = true
        }

        if (Object.keys(errObj).length !== 0) {
          errAllObj.details[index] = errObj
        }
      }
    }

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'details',
      value: errAllObj,
    })

    return handleFindErr(errAllObj)
  }

  const handleCheckValidOverUbUpperLimitMonthlyAmount = (data: any) => {
    const errAllObj: any = {}

    if (
      data.upperLimit.ubAfterCostTotal >
      data.upperLimit.ubUpperLimitMonthlyAmount
    ) {
      errAllObj.ub = []

      for (let index = 0; index < data.upperLimit.ub.length; index++) {
        const errObj: any = {}

        if (
          Object.keys(data.upperLimit.ub[index]).some(
            (subkey: string) =>
              data.upperLimit.ub[index][subkey] ||
              data.upperLimit.ub[index][subkey] === 0
          )
        ) {
          errObj.ubAfterCost = true
          errAllObj.ub[index] = errObj
        }

        if (Object.keys(errObj).length !== 0) {
          errAllObj.ub[index] = errObj
        }
      }

      context.root.$store.commit('childrenValid/valueTargeErrSet', {
        key: 'upperLimit',
        value: errAllObj,
      })
    }

    return handleFindErr(errAllObj)
  }

  const handleNotRegistServiceCodeCheck = (data: any, errorList: any) => {
    const errAllObj: any = {}

    errAllObj.details = []

    for (let index = 0; index < data.details.details.length; index++) {
      if (
        data.details.details[index] &&
        data.details.details[index].beServiceCode &&
        errorList.some(
          (serviceCode: string) =>
            data.details.details[index].beServiceCode === serviceCode
        )
      ) {
        errAllObj.details[index] = {
          beServiceCode: true,
        }
      }
    }

    context.root.$store.commit('childrenValid/valueTargeErrSet', {
      key: 'details',
      value: errAllObj,
    })
  }

  const handleDiffCheckDetailsOfBatUbCost = (
    master: any,
    transaction: any,
    errViewArray: string[]
  ) => {
    let isDiffBatUbCost = false
    try {
      const checkKeysArray: string[] = ['manyChildrenNo', 'freeOfCharge']

      const targetManyChildrenNoArray = defineObject.MANY_CHILDREN_NO_ARRAY.filter(
        (manyObj: { [key: string]: string }) => manyObj.value !== '1'
      )

      checkKeysArray.forEach((checkKey: string) => {
        switch (checkKey) {
          case 'freeOfCharge':
            if (
              transaction[checkKey] !== undefined &&
              master[checkKey] !== transaction[checkKey]
            ) {
              throw new Error('')
            }

            if (
              transaction[checkKey] === undefined &&
              master[checkKey] === '1'
            ) {
              throw new Error('')
            }
            break

          case 'manyChildrenNo':
            if (
              transaction[checkKey] !== undefined &&
              master[checkKey] !== transaction[checkKey]
            ) {
              throw new Error('')
            }

            if (
              transaction[checkKey] === undefined &&
              targetManyChildrenNoArray.some(
                (manyObj: { [key: string]: string }) =>
                  manyObj.value === master[checkKey]
              )
            ) {
              throw new Error('')
            }
            break
        }
      })

      if (
        transaction.summary.some(
          (summary: { batUbCost: number; batTotalCost: number }) =>
            Number(summary.batUbCost) !== 0 &&
            Number(summary.batUbCost) !==
              Math.floor(
                Number(new BigNumber(summary.batTotalCost).times(0.05))
              ) &&
            Number(summary.batUbCost) !==
              Math.floor(Number(new BigNumber(summary.batTotalCost).times(0.1)))
        )
      ) {
        throw new Error('')
      }
    } catch (error) {
      isDiffBatUbCost = true
    }

    if (isDiffBatUbCost) {
      errViewArray.push(`・利用者負担額②が異なります。`)
    }
  }

  const handleDiffCheckDetailsOfServiceArray = (
    masterServiceArray: ServiceType[],
    transactionServiceArray: ServiceType[],
    errViewArray: string[]
  ) => {
    type checkServiceTypeKey = keyof Pick<
      ServiceType,
      'startDate' | 'useDay' | 'endDate'
    >

    const detailsCheckServiceInfoKeyArray: {
      checkKey: checkServiceTypeKey
      msg: string
    }[] = [
      {
        checkKey: 'startDate',
        msg: 'サービス種別の開始年月日',
      },
      {
        checkKey: 'endDate',
        msg: 'サービス種別の終了年月日',
      },
      {
        checkKey: 'useDay',
        msg: '利用日数',
      },
    ]

    if (
      Array.isArray(masterServiceArray) &&
      Array.isArray(transactionServiceArray)
    ) {
      masterServiceArray.forEach((masterServiceData: ServiceType) => {
        const serviceDiffMsgArray = []

        for (
          let index = 0;
          index < detailsCheckServiceInfoKeyArray.length;
          index++
        ) {
          const checkObj = detailsCheckServiceInfoKeyArray[index]
          if (
            transactionServiceArray.find(
              (serviceData: ServiceType) =>
                serviceData.serviceCodeType ===
                  masterServiceData.serviceCodeType &&
                String(serviceData[checkObj.checkKey]) !==
                  String(masterServiceData[checkObj.checkKey])
            )
          ) {
            serviceDiffMsgArray.push(checkObj.msg)
          }
        }

        if (serviceDiffMsgArray.length !== 0) {
          errViewArray.push(
            `・サービス種別が${
              masterServiceData.serviceCodeType
            }の${serviceDiffMsgArray.join(',')}が異なります。`
          )
        }
      })

      const masterServiceCodeTypeArray = masterServiceArray.map(
        (masterServiceItem: ServiceType) => masterServiceItem.serviceCodeType
      )

      const transactionServiceCodeTypeArray = transactionServiceArray.map(
        (serviceItem: ServiceType) => serviceItem.serviceCodeType
      )

      const serviceCodeTypeDiffArray1 = difference(
        masterServiceCodeTypeArray,
        transactionServiceCodeTypeArray
      )

      const serviceCodeTypeDiffArray2 = difference(
        transactionServiceCodeTypeArray,
        masterServiceCodeTypeArray
      )

      const serviceCodeTypeDiffArray = Array.from(
        new Set(serviceCodeTypeDiffArray1.concat(serviceCodeTypeDiffArray2))
      )

      if (serviceCodeTypeDiffArray.length !== 0) {
        const serviceCodeTypeContentsDiffArray: string[] = []

        serviceCodeTypeDiffArray.forEach((serviceCodeType: string) => {
          let diffServiceItem = masterServiceArray.find(
            (masterServiceItem: ServiceType) =>
              masterServiceItem.serviceCodeType === serviceCodeType
          )

          if (!diffServiceItem) {
            diffServiceItem = transactionServiceArray.find(
              (summayItem: ServiceType) =>
                summayItem.serviceCodeType === serviceCodeType
            )
          }

          if (diffServiceItem) {
            serviceCodeTypeContentsDiffArray.push(
              diffServiceItem.serviceCodeType
            )
          }
        })

        if (serviceCodeTypeContentsDiffArray.length !== 0) {
          errViewArray.push(
            `・${serviceCodeTypeContentsDiffArray.join()}のサービス種別が異なります。`
          )
        }
      }
    }
  }

  const handleDiffCheckDetailsOfSummaryArray = (
    masterSummaryArray: SummaryType[],
    transactionSummaryArray: SummaryType[],
    errViewArray: string[]
  ) => {
    type checkSummaryTypeKey = keyof Pick<
      SummaryType,
      'batServiceUseDay' | 'batUnits'
    >

    const detailsCheckSummaryKeyArray: {
      checkKey: checkSummaryTypeKey
      msg: string
    }[] = [
      {
        checkKey: 'batServiceUseDay',
        msg: 'サービス利用日数',
      },
      {
        checkKey: 'batUnits',
        msg: '単位数単価',
      },
    ]

    if (
      Array.isArray(masterSummaryArray) &&
      Array.isArray(transactionSummaryArray)
    ) {
      masterSummaryArray.forEach((masterSummaryData: SummaryType) => {
        const summaryDiffMsgArray = []

        for (
          let index = 0;
          index < detailsCheckSummaryKeyArray.length;
          index++
        ) {
          const checkObj = detailsCheckSummaryKeyArray[index]
          if (
            transactionSummaryArray.find(
              (summaryData: SummaryType) =>
                summaryData.batServiceCodeType ===
                  masterSummaryData.batServiceCodeType &&
                summaryData[checkObj.checkKey] !==
                  masterSummaryData[checkObj.checkKey]
            )
          ) {
            summaryDiffMsgArray.push(checkObj.msg)
          }
        }

        if (summaryDiffMsgArray.length !== 0) {
          errViewArray.push(
            `・サービス種類コードが${
              masterSummaryData.batServiceCodeType
            }の${summaryDiffMsgArray.join(',')}が異なります。`
          )
        }
      })

      const masterBatServiceCodeTypeArray = masterSummaryArray.map(
        (masterSummaryItem: SummaryType) => masterSummaryItem.batServiceCodeType
      )

      const transactionBatServiceCodeTypeArray = transactionSummaryArray.map(
        (summaryItem: SummaryType) => summaryItem.batServiceCodeType
      )

      const batServiceCodeTypeDiffArray1 = difference(
        masterBatServiceCodeTypeArray,
        transactionBatServiceCodeTypeArray
      )

      const batServiceCodeTypeDiffArray2 = difference(
        transactionBatServiceCodeTypeArray,
        masterBatServiceCodeTypeArray
      )

      const batServiceCodeTypeDiffArray = Array.from(
        new Set(
          batServiceCodeTypeDiffArray1.concat(batServiceCodeTypeDiffArray2)
        )
      )

      if (batServiceCodeTypeDiffArray.length !== 0) {
        const batServiceCodeTypeContentsDiffArray: string[] = []

        batServiceCodeTypeDiffArray.forEach((batServiceCodeType: string) => {
          let diffSummayItem = masterSummaryArray.find(
            (masterSummayItem: SummaryType) =>
              masterSummayItem.batServiceCodeType === batServiceCodeType
          )

          if (!diffSummayItem) {
            diffSummayItem = transactionSummaryArray.find(
              (summayItem: SummaryType) =>
                summayItem.batServiceCodeType === batServiceCodeType
            )
          }

          if (diffSummayItem) {
            const targetServiceCodeTypeAndAffiliationItem = defineObject.SERVICE_CODE_TYPE_AND_AFFILIATION_ARRAY.find(
              (
                serviceCodeTypeAndAffiliationItem: ServiceCodeTypeAndAffiliationType
              ) =>
                serviceCodeTypeAndAffiliationItem.serviceCodeType ===
                diffSummayItem?.batServiceCodeType
            )

            batServiceCodeTypeContentsDiffArray.push(
              String(targetServiceCodeTypeAndAffiliationItem?.serviceName)
            )
          }
        })

        if (batServiceCodeTypeContentsDiffArray.length !== 0) {
          errViewArray.push(
            `・${batServiceCodeTypeContentsDiffArray.join()}の集計が異なります。`
          )
        }
      }
    }
  }

  const handleDiffCheckDetailsOfDetails = (
    masterDetailsArray: DetailsItemType[],
    transactionDetailsArray: DetailsItemType[],
    errViewArray: string[],
    isParents = false
  ) => {
    type checkDetailsTypeKey = keyof Pick<
      DetailsItemType,
      'beUnits' | 'beCount' | 'beServiceContents'
    >

    const beServiceContentsLabel = isParents ? '項目名' : 'サービス内容'

    const detailsCheckDetailsKeyArray: {
      checkKey: checkDetailsTypeKey
      msg: string
    }[] = [
      {
        checkKey: 'beUnits',
        msg: '単位数',
      },
      {
        checkKey: 'beCount',
        msg: '回数',
      },
      {
        checkKey: 'beServiceContents',
        msg: beServiceContentsLabel,
      },
    ]

    if (
      Array.isArray(masterDetailsArray) &&
      Array.isArray(transactionDetailsArray)
    ) {
      masterDetailsArray.forEach((masterDetailsData: DetailsItemType) => {
        const detailsDiffMsgArray = []

        for (
          let index = 0;
          index < detailsCheckDetailsKeyArray.length;
          index++
        ) {
          const checkObj = detailsCheckDetailsKeyArray[index]

          // 処遇、身体拘束廃止未実施減算、ベースアップ等の別のサービスコードの回数や、単位数で可変するものは単位数、回数差分チェックから除外する
          if (
            transactionDetailsArray.find(
              (detailsData: DetailsItemType) =>
                !(
                  handleIsVariableServiceCode(
                    masterDetailsData.beServiceCode
                  ) || handleIsVariableServiceCode(detailsData.beServiceCode)
                ) &&
                detailsData.beServiceCode === masterDetailsData.beServiceCode &&
                String(detailsData[checkObj.checkKey]) !==
                  String(masterDetailsData[checkObj.checkKey])
            )
          ) {
            detailsDiffMsgArray.push(checkObj.msg)
          }

          // 特別地域加算のみ 回数のみチェック対象として再チェックを別途実施
          if (
            checkObj.checkKey === 'beCount' &&
            transactionDetailsArray.find(
              (detailsData: DetailsItemType) =>
                masterDetailsData.beServiceCode === '646770' &&
                detailsData.beServiceCode === masterDetailsData.beServiceCode &&
                String(detailsData[checkObj.checkKey]) !==
                  String(masterDetailsData[checkObj.checkKey])
            )
          ) {
            detailsDiffMsgArray.push(checkObj.msg)
          }
        }

        if (detailsDiffMsgArray.length !== 0) {
          errViewArray.push(
            `・${beServiceContentsLabel}が${
              masterDetailsData.beServiceContents
            }の${detailsDiffMsgArray.join(',')}が異なります。`
          )
        }
      })

      const masterBeServiceCodeArray = masterDetailsArray.map(
        (masterItemDetails: any) => masterItemDetails.beServiceCode
      )
      const transactionBeServiceCodeArray = transactionDetailsArray.map(
        (itemDetails: any) => itemDetails.beServiceCode
      )

      const beServiceCodeDiffArray1 = difference(
        masterBeServiceCodeArray,
        transactionBeServiceCodeArray
      )

      const beServiceCodeDiffArray2 = difference(
        transactionBeServiceCodeArray,
        masterBeServiceCodeArray
      )

      const beServiceCodeDiffArray = Array.from(
        new Set(beServiceCodeDiffArray1.concat(beServiceCodeDiffArray2))
      )

      if (beServiceCodeDiffArray.length !== 0) {
        const beServiceContentsDiffArray: string[] = []

        beServiceCodeDiffArray.forEach((beServiceCode: string) => {
          let diffDetailsItem = masterDetailsArray.find(
            (masterDetailsItem: DetailsItemType) =>
              masterDetailsItem.beServiceCode === beServiceCode
          )

          if (!diffDetailsItem) {
            diffDetailsItem = transactionDetailsArray.find(
              (masterDetailsItem: DetailsItemType) =>
                masterDetailsItem.beServiceCode === beServiceCode
            )
          }

          if (diffDetailsItem) {
            beServiceContentsDiffArray.push(diffDetailsItem.beServiceContents)
          }
        })

        if (beServiceContentsDiffArray.length !== 0) {
          errViewArray.push(
            `・${beServiceContentsDiffArray.join()}の明細が異なります。`
          )
        }
      }
    }
  }

  const handleDiffCheckDetails = (master: any, transaction: any) => {
    const errViewArray: string[] = []

    const detailsNameInfoKeyArray: { [key: string]: string }[] = [
      {
        checkKey: 'parentsName',
        msg: '給付決定保護者氏名',
      },
      {
        checkKey: 'childName',
        msg: '給付決定に係る障害児氏名',
      },
    ]

    detailsNameInfoKeyArray.forEach((checkObj: { [key: string]: string }) => {
      if (
        !(
          transaction[checkObj.checkKey] !== null &&
          transaction[checkObj.checkKey] !== undefined &&
          transaction[checkObj.checkKey].replace(/\s+/g, '') ===
            master[checkObj.checkKey].replace(/\s+/g, '')
        )
      ) {
        errViewArray.push(`・${checkObj.msg}が異なります。`)
      }
    })

    const detailsCheckCldAndOfficeInfoKeyArray: { [key: string]: string }[] = [
      {
        checkKey: 'municipalitiesNo',
        msg: '都道府県等番号',
      },
      {
        checkKey: 'beneficiaryId',
        msg: '受給者証番号',
      },
      {
        checkKey: 'billingOfficeNumber',
        msg: '請求事業者の指定事業所番号',
      },
      {
        checkKey: 'billingOfficeName',
        msg: '請求事業者の事業者及びその事業所の名称',
      },
      {
        checkKey: 'officeNumber',
        msg: '利用者負担上限額管理事業所の指定事業所番号',
      },
      {
        checkKey: 'officeName',
        msg: '利用者負担上限額管理事業所の事業所名称',
      },
    ]

    detailsCheckCldAndOfficeInfoKeyArray.forEach(
      (checkObj: { [key: string]: string }) => {
        if (
          !(
            transaction[checkObj.checkKey] !== null &&
            transaction[checkObj.checkKey] !== undefined &&
            transaction[checkObj.checkKey] === master[checkObj.checkKey]
          )
        ) {
          errViewArray.push(`・${checkObj.msg}が異なります。`)
        }
      }
    )

    const detailsChecNumberkCldAndOfficeInfoKeyArray: {
      [key: string]: string
    }[] = [
      {
        checkKey: 'ubUpperLimitMonthlyAmount',
        msg: '利用者負担上限月額①',
      },
    ]

    detailsChecNumberkCldAndOfficeInfoKeyArray.forEach(
      (checkObj: { [key: string]: string }) => {
        if (
          !(
            transaction[checkObj.checkKey] !== null &&
            transaction[checkObj.checkKey] !== undefined &&
            Number(transaction[checkObj.checkKey]) ===
              Number(master[checkObj.checkKey])
          )
        ) {
          errViewArray.push(`・${checkObj.msg}が異なります。`)
        }
      }
    )

    handleDiffCheckDetailsOfServiceArray(
      master.service,
      transaction.service,
      errViewArray
    )

    handleDiffCheckDetailsOfDetails(
      master.details,
      transaction.details,
      errViewArray
    )

    handleDiffCheckDetailsOfSummaryArray(
      master.summary,
      transaction.summary,
      errViewArray
    )

    handleDiffCheckDetailsOfBatUbCost(master, transaction, errViewArray)

    return errViewArray
  }

  const handleDiffCheckUpperLimit = (
    master: any,
    transaction: any,
    isCsvReBilling = false
  ) => {
    console.log(master, transaction)
    const errViewArray: string[] = []

    let targetTransactionUbArray = transaction.ub.filter(
      (ubItem: ubItem) => ubItem.ubBeneficiaryId === transaction.beneficiaryId
    )

    if (isCsvReBilling) {
      targetTransactionUbArray = transaction.ub
    }

    // ub.officeNumber,ub.officeNameがmasterにあって、transactionにない、transactionにあって、masterにない
    // 事業所番号が一致している場合に事業所名が一致していない
    // 事業所名が一致している場合に事業所番号が一致していない

    master.ub.forEach((masterUbItem: any) => {
      const targetUb = targetTransactionUbArray.find(
        (ubItem: any) =>
          masterUbItem.ubOfficeNumber === ubItem.ubOfficeNumber &&
          masterUbItem.ubOfficeName !== ubItem.ubOfficeName
      )

      if (targetUb) {
        errViewArray.push(
          `・${targetUb.ubOfficeNumber}の事業所番号に該当する事業所名が異なります。`
        )
      }
    })

    const masterUbOfficeNumberArray: string[] = master.ub.map(
      (masterUbItem: ubItem) => masterUbItem.ubOfficeNumber
    )
    const transactionUbOfficeNumberArray: string[] = targetTransactionUbArray.map(
      (ubItem: ubItem) => ubItem.ubOfficeNumber
    )

    const ubOfficeNumberDiffArray1 = difference(
      masterUbOfficeNumberArray,
      transactionUbOfficeNumberArray
    )

    const ubOfficeNumberDiffArray2 = difference(
      transactionUbOfficeNumberArray,
      masterUbOfficeNumberArray
    )

    const ubOfficeNumberDiffArray = Array.from(
      new Set(ubOfficeNumberDiffArray1.concat(ubOfficeNumberDiffArray2))
    )

    if (ubOfficeNumberDiffArray.length !== 0) {
      errViewArray.push(
        `・${ubOfficeNumberDiffArray.join()}の事業所番号に該当する事業所の利用者負担額集計・調整が異なります。`
      )
    }

    return errViewArray
  }

  const handleShapeUpperLimitUbArray = (billingDetailsAndUpperLimitDataObj: {
    upperLimit: {
      ub: ubItem[]
    }
  }) => {
    if (
      billingDetailsAndUpperLimitDataObj.upperLimit.ub &&
      billingDetailsAndUpperLimitDataObj.upperLimit.ub.length !== 0
    ) {
      const filterUbArray = billingDetailsAndUpperLimitDataObj.upperLimit.ub.filter(
        (ubItem: any) =>
          Object.keys(ubItem).some(
            (ubKey: string) =>
              ubItem[ubKey] !== undefined &&
              ubItem[ubKey] !== null &&
              ubItem[ubKey] !== ''
          )
      )
      billingDetailsAndUpperLimitDataObj.upperLimit.ub = filterUbArray
    }
  }

  const handleCheckValidOverUbUpperLimitMonthlyAmountOfDetails = (billingDetailsAndUpperLimitDataObj: {
    upperLimit: upperLimitState
    details: DetailsState
  }) => {
    let res = false

    if (
      Number(
        billingDetailsAndUpperLimitDataObj.details.ubUpperLimitMonthlyAmount
      ) <
      Number(
        billingDetailsAndUpperLimitDataObj.details.summaryTotal
          .batDecisionUbCostTotal
      )
    ) {
      res = true
    }

    return res
  }

  const handleDetailsAndUpperLimitValidByCld = (billingDetailsAndUpperLimitDataObj: {
    upperLimit: upperLimitState
    details: DetailsState
  }) => {
    try {
      handleShapeUpperLimitUbArray(billingDetailsAndUpperLimitDataObj)

      // 上限管理が自社の場合のみチェック
      if (billingDetailsAndUpperLimitDataObj.upperLimit.ub.length !== 0) {
        const emptyUpperLimitRes = handleCheckValidUpperLimit(
          billingDetailsAndUpperLimitDataObj
        )

        // 空チェック(上限管理) 判定
        if (emptyUpperLimitRes) {
          alert(
            '利用者負担上限額管理結果票の必須項目で未入力の項目があります。'
          )
          throw new Error('valid')
        }

        const isResultCostAndUbAfterCostCheck = handleCheckResultCostAndUpperLimitOwnUbOfficeNumberMaster(
          billingDetailsAndUpperLimitDataObj
        )

        if (isResultCostAndUbAfterCostCheck) {
          alert(
            '障害児通所給付費・入所給付費等明細書（様式第二）の管理結果額と利用者負担上限額管理結果票の自社の管理結果後利用者負担額が一致しておりません。'
          )
          throw new Error('valid')
        }

        // 空チェックを通過できたら上限管理の利用者上限負担額の判定
        const overUbUpperLimitMonthlyAmount = handleCheckValidOverUbUpperLimitMonthlyAmount(
          billingDetailsAndUpperLimitDataObj
        )

        if (overUbUpperLimitMonthlyAmount) {
          alert(
            '利用者負担上限額管理結果票の管理結果後利用者負担額が利用者上限負担額を超過しています。'
          )
          throw new Error('valid')
        }
      }

      // 空チェック[様式第二]
      const emptyDetailsRes = handleCheckValidDetails(
        billingDetailsAndUpperLimitDataObj
      )

      // 空チェック(様式第二) 判定
      if (emptyDetailsRes) {
        alert(
          '利用者負担上限額管理結果票または障害児通所給付費・入所給付費等明細書（様式第二）の必須項目で未入力の項目があります。'
        )
        throw new Error('valid')
      }

      // サービスコード重複チェック
      const duplicateCheckRes = handleCheckValidDuplicateServiceCodeCheckRes(
        billingDetailsAndUpperLimitDataObj
      )

      if (duplicateCheckRes) {
        alert(
          '障害児通所給付費・入所給付費等明細書（様式第二）の給付費明細欄のサービスコードが重複しております。'
        )
        throw new Error('valid')
      }

      // サービス種別とサービスコードチェック
      const isDiffServiceTypeByServiceCode = handleCheckValidServiceCodeTypeAndServiceCodeCheckRes(
        billingDetailsAndUpperLimitDataObj
      )

      if (isDiffServiceTypeByServiceCode) {
        alert(
          '障害児通所給付費・入所給付費等明細書（様式第二）のサービス種別と異なるサービスコードが給付費明細欄に存在しております。'
        )
        throw new Error('valid')
      }

      // 利用者負担額①よりも決定利用者負担額が超過していないか確認する
      const overUbUpperLimitMonthlyAmountOfDetails = handleCheckValidOverUbUpperLimitMonthlyAmountOfDetails(
        billingDetailsAndUpperLimitDataObj
      )

      if (overUbUpperLimitMonthlyAmountOfDetails) {
        alert('決定利用者負担額が利用者負担上限月額①を超過しています。')
        throw new Error('valid')
      }

      // 空チェックを通過できたら桁数チェック[様式第二]
      const cntDetailsRes = handleCheckValidCnt(
        billingDetailsAndUpperLimitDataObj
      )

      if (cntDetailsRes) {
        alert(
          '利用者負担上限額管理結果票または障害児通所給付費・入所給付費等明細書（様式第二）の入力した内容の計算結果の桁数が基準値を超過しているか、計算結果が0未満の項目があります。入力内容を修正してください。'
        )
        throw new Error('valid')
      }

      // 上限管理が自社の場合のみチェック（管理結果の値を催促する）
      if (billingDetailsAndUpperLimitDataObj.upperLimit.ub.length !== 0) {
        if (
          Number(
            billingDetailsAndUpperLimitDataObj.upperLimit.ubUpperLimitResult
          ) !==
          Number(
            billingDetailsAndUpperLimitDataObj.upperLimit.resultNoPlaceholder
          )
        ) {
          const res = confirm(
            `利用者負担上限額管理結果に「${billingDetailsAndUpperLimitDataObj.upperLimit.resultNoPlaceholder}」を設定して保存しますか？\n入力中の値：${billingDetailsAndUpperLimitDataObj.upperLimit.ubUpperLimitResult}`
          )

          if (res) {
            context.root.$store.commit('upperLimit/valueTargeSet', {
              key: 'ubUpperLimitResult',
              value:
                billingDetailsAndUpperLimitDataObj.upperLimit
                  .resultNoPlaceholder,
            })
          }
        }
      }

      return true
    } catch (error) {
      return false
    }
  }

  return {
    handleFindErr,
    handleCheckValidUpperLimit,
    handleCheckValidDetails,
    handleCheckValidCnt,
    handleCheckValidDuplicateServiceCodeCheckRes,
    handleCheckValidServiceCodeTypeAndServiceCodeCheckRes,
    handleCheckValidOverUbUpperLimitMonthlyAmount,
    handleNotRegistServiceCodeCheck,
    handleDiffCheckDetails,
    handleDiffCheckUpperLimit,
    handleCheckValidRowCnt,
    handleCheckValidDetailsOnly,
    handleCheckValidUpperLimitBrotherArray,
    handleCheckValidBrotherUpperLimit,
    handleCheckValidDuplicateUbCldUpperLimitNumberAndUbOfficeNumber,
    handleCheckValidOnlyOwnUbOfficeNumber,
    handleCheckResultCostAndUpperLimitOwnUbOfficeNumberMaster,
    handleDiffCheckDetailsOfDetails,
    handleDetailsAndUpperLimitValidByCld,
  }
}

export const handleShapePostFilterDetailsArray = (
  detailsArray: DetailsItemType[]
) => {
  const detailsfilterArray = detailsArray.filter(
    (data: DetailsItemType) => data && data.beServiceCode
  )

  return detailsfilterArray
}

export const useResetUpperLimit = () => {
  const initUpperLimit = (upperLimit: upperLimitState) => {
    upperLimit.date = ''
    upperLimit.ubUpperLimitMonthlyAmount = ''
    upperLimit.ub = []
    upperLimit.officeNumber = ''
    upperLimit.resultNoPlaceholder = ''
    upperLimit.ubTotal = ''
    upperLimit.ubCostTotal = ''
    upperLimit.ubAfterCostTotal = ''
    upperLimit.officeName = ''
    upperLimit.brotherArray = []
    upperLimit.beneficiaryId = ''
    upperLimit.ubUpperLimitResult = ''
    upperLimit.municipalitiesNo = ''
    upperLimit.parentsName = ''
    upperLimit.childName = ''
  }

  const initDetailsOfUpperLimitServiceCode = (details: DetailsState) => {
    details.details = details.details.filter(
      (detailsItem: DetailsItemType) =>
        detailsItem.beServiceCode.slice(2) !== '5370'
    )
  }

  const initDetailsOfUpperLimit = (details: DetailsState) => {
    details.officeName = ''
    details.officeNumber = ''
    details.resultNo = ''
    details.resultCost = ''

    initDetailsOfUpperLimitServiceCode(details)
  }

  return {
    initDetailsOfUpperLimitServiceCode,
    initDetailsOfUpperLimit,
    initUpperLimit,
  }
}

export const useSet = (state: any, context: SetupContext) => {
  const {
    handleCheckValidDetailsOnly,
    handleCheckValidDuplicateServiceCodeCheckRes,
    handleCheckValidServiceCodeTypeAndServiceCodeCheckRes,
    handleCheckValidRowCnt,
  } = useValid(context)

  const {
    initDetailsOfUpperLimitServiceCode,
    initUpperLimit,
    initDetailsOfUpperLimit,
  } = useResetUpperLimit()

  const existData = (arrayLength: number) => {
    if (arrayLength === 0) {
      alert(`請求データが1つもありません。`)
      return
    }
  }

  const handleNullToEmptyString = (data: any) => {
    Object.keys(data).forEach(key => {
      if (
        (data[key] && typeof data[key] === 'object') ||
        Array.isArray(data[key])
      ) {
        return handleNullToEmptyString(data[key])
      } else {
        if (data[key] === null || data[key] === undefined) {
          data[key] = ''
          return true
        } else {
          return true
        }
      }
    })

    return data
  }

  const handleUpperLimitInit = (detailsAndUpperLimit: any) => {
    initDetailsOfUpperLimitServiceCode(detailsAndUpperLimit.details.master)

    initUpperLimit(detailsAndUpperLimit.upperLimit.master)

    return detailsAndUpperLimit
  }

  const handleResetUpperLimit = () => {
    const { handleCalcDetails } = useSet(state, context)

    const res = window.confirm(
      '上限額管理事業所の情報を使わずに請求を行います。よろしいですか？'
    )

    if (res) {
      handleErrReset(context)

      if (state.isBrotherUpperLimit) {
        state.isBrotherUpperLimit = false
      }

      const resetBillingChildPararm = JSON.parse(
        JSON.stringify(state.claimChildParam.dataObject)
      )

      initDetailsOfUpperLimit(resetBillingChildPararm.details)

      initUpperLimit(resetBillingChildPararm.upperLimit)

      context.root.$store.commit(
        'details/valueSet',
        JSON.parse(JSON.stringify(resetBillingChildPararm.details))
      )

      context.root.$store.commit(
        'upperLimit/valueSet',
        JSON.parse(JSON.stringify(resetBillingChildPararm.upperLimit))
      )

      context.root.$nextTick(() => {
        setTimeout(() => {
          handleCalcDetails(state.isReBilling)
        }, 500)
      })
    }
  }

  const handleBrotherUpperLimitAnotherManagementFlgUpdateBillingData = (
    detailsAndUpperLimit: any
  ) => {
    // きょうだい上限管理されている児童かどうか
    if (detailsAndUpperLimit.brotherUpperLimitAnotherManagementFlg) {
      detailsAndUpperLimit = handleUpperLimitInit(detailsAndUpperLimit)
    }

    return detailsAndUpperLimit
  }

  const handleNotBeneficiaryIdUpdateBillingData = (
    detailsAndUpperLimit: any
  ) => {
    // 受給者番号がなしかどうかをチェックする

    if (
      !handleIsbeneficiaryIdView(
        detailsAndUpperLimit.details.master.beneficiaryId
      ) &&
      detailsAndUpperLimit.upperLimit.master.ub.length !== 0
    ) {
      detailsAndUpperLimit = handleUpperLimitInit(detailsAndUpperLimit)
    }

    return detailsAndUpperLimit
  }

  const handlePresetUpperLimitMasterUbData = (detailsAndUpperLimit: any) => {
    // 上限管理自社かどうかチェック

    if (
      detailsAndUpperLimit.upperLimit.master.ub &&
      detailsAndUpperLimit.upperLimit.master.ub.length !== 0
    ) {
      const ubItemsArray: ubItem[] = Array.from(
        detailsAndUpperLimit.upperLimit.master.ub
      )

      detailsAndUpperLimit.upperLimit.master.ub = ubItemsArray.map(
        (ubItem: ubItem) => {
          ubItem.ubCldUpperLimitNumber = 1

          ubItem.ubBeneficiaryId =
            detailsAndUpperLimit.details.master.beneficiaryId

          return ubItem
        }
      )
    }

    return detailsAndUpperLimit
  }

  const handlePresetDetailsSaData = (cldReBillingDataByCld: any) => {
    cldReBillingDataByCld.details.master.saBeBillingCost = ''
    cldReBillingDataByCld.details.master.saActualCost = ''
    cldReBillingDataByCld.details.master.saDailyAmount = ''
    cldReBillingDataByCld.details.master.saDay = ''

    return cldReBillingDataByCld
  }

  const handlePresetDetailsSummaryItemDataByCsvReBilling = (
    cldReBillingDataByCld: any
  ) => {
    cldReBillingDataByCld.details.master.summary = cldReBillingDataByCld.details.master.summary.map(
      (summaryItem: SummaryType) => {
        summaryItem.batBillingGrantMunicipal = summaryItem.batBillingGrantMunicipal
          ? summaryItem.batBillingGrantMunicipal
          : '0'

        return summaryItem
      }
    )

    return cldReBillingDataByCld
  }

  const handlePresetDetailsSummaryItemData = (cldReBillingDataByCld: any) => {
    cldReBillingDataByCld.details.master.summary = cldReBillingDataByCld.details.master.summary.map(
      (summaryItem: SummaryType) => {
        // 調整後利用者負担額、上限額管理後利用者負担額に値を格納するかはフロントで総計算時に設定するため、master側はいったん初期化する
        summaryItem.batAfterCost = ''
        summaryItem.batAfterUpperLimitCost = ''
        summaryItem.batBillingGrantMunicipal = summaryItem.batBillingGrantMunicipal
          ? summaryItem.batBillingGrantMunicipal
          : '0'

        return summaryItem
      }
    )

    return cldReBillingDataByCld
  }

  const handlePreSetData = (cldReBillingDataByCld: any) => {
    // 上限管理結果の金額がデータが存在する列かつ、金額の値が空の場合はデフォルトで0をセットする
    const upperLimitUbDefaultSetTargetKeyArray = ['ubTotalCost', 'ubCost']

    if (
      cldReBillingDataByCld.upperLimit.master.ub.every(
        (data: any) => data.ubOfficeNumber
      )
    ) {
      cldReBillingDataByCld.upperLimit.master.ub = cldReBillingDataByCld.upperLimit.master.ub.map(
        (data: any) => {
          Object.keys(data).forEach(key => {
            if (
              upperLimitUbDefaultSetTargetKeyArray.includes(key) &&
              data[key] === ''
            ) {
              data[key] = 0
            }
          })
          return data
        }
      )

      cldReBillingDataByCld.upperLimit.master.ub = cldReBillingDataByCld.upperLimit.master.ub.map(
        (data: any) => {
          Object.keys(data).forEach(key => {
            if (
              key === 'ubAfterCost' &&
              data[key] === '' &&
              String(data.ubOfficeNumber) !==
                String(cldReBillingDataByCld.upperLimit.officeNumber)
            ) {
              data[key] = 0
            }
          })
          return data
        }
      )
    }

    cldReBillingDataByCld = handleShapeBilling([cldReBillingDataByCld])[0]

    return cldReBillingDataByCld
  }

  const handleSetBillingUpdateParamVisitChildFlgAndAffiliation = (
    dataObject: BillingPostParamType
  ) => {
    dataObject.visitChildFlg = '0'

    const targetBillingAffiliationArray = handleGetAffiliationDetails(
      dataObject.details
    )

    if (
      targetBillingAffiliationArray.some(
        (targetBillingAffiliation: { affiliation: string }) =>
          targetBillingAffiliation.affiliation === '2'
      )
    ) {
      dataObject.visitChildFlg = '1'
    }

    dataObject.affiliation = ''

    if (targetBillingAffiliationArray[0]) {
      dataObject.affiliation = String(
        targetBillingAffiliationArray[0].affiliation
      )
    }
  }

  const handleCalcDetails = (isReBilling = false) => {
    state.calcErrMsg = ''
    state.isChanging = true

    const dataObject = JSON.parse(
      JSON.stringify(state.claimChildParam.dataObject)
    ) as BillingPostParamType

    dataObject.act = 'recalculation'

    const paramYear = ('0000' + state.targetYear).slice(-4)

    const paramMonth = ('00' + state.targetMonth).slice(-2)

    dataObject.date = `${paramYear}/${paramMonth}`

    handleSetBillingUpdateParamVisitChildFlgAndAffiliation(dataObject)

    let api = state.claimChildParam.api

    if (isReBilling) {
      api = 'anew_billing'
      dataObject.act = 'anewBeUpdate'
    }

    state.claimChildParam.dataObject = handleNullToEmptyString(
      state.claimChildParam.dataObject
    )

    // 空チェック[様式第二]
    const emptyDetailsRes = handleCheckValidDetailsOnly(
      state.claimChildParam.dataObject
    )

    // 空チェック(様式第二) 判定
    if (emptyDetailsRes) {
      state.isChanging = false
      return
    }

    // サービスコード重複チェック
    const duplicateCheckRes = handleCheckValidDuplicateServiceCodeCheckRes(
      state.claimChildParam.dataObject
    )

    if (duplicateCheckRes) {
      state.calcErrMsg =
        '障害児通所給付費・入所給付費等明細書（様式第二）の給付費明細欄のサービスコードが重複しております。'
      state.isChanging = false
      return
    }

    // サービス種別とサービスコードチェック
    const isDiffServiceTypeByServiceCode = handleCheckValidServiceCodeTypeAndServiceCodeCheckRes(
      state.claimChildParam.dataObject
    )

    if (isDiffServiceTypeByServiceCode) {
      state.calcErrMsg =
        '障害児通所給付費・入所給付費等明細書（様式第二）のサービス種別と異なるサービスコードが給付費明細欄に存在しております。'

      state.isChanging = false
      return
    }

    // 空チェックを通過できたら桁数チェック[様式第二]
    const cntDetailsRes = handleCheckValidRowCnt(
      state.claimChildParam.dataObject
    )

    if (cntDetailsRes) {
      state.calcErrMsg =
        '利用者負担上限額管理結果票または障害児通所給付費・入所給付費等明細書（様式第二）の入力した内容の計算結果の桁数が基準値を超過しているか、計算結果が0未満の項目があります。入力内容を修正してください。'

      state.isChanging = false
      return
    }

    valueCovidZZ01CalculationSet(dataObject.details)
    valueSubtractionZ001CalculationSet(dataObject.details)
    handleBeUnitsSet(dataObject.details)

    dataObject.details.details = handleShapePostFilterDetailsArray(
      dataObject.details.details
    )

    const claimChildPromise = apiConnect.postToApiGateway(api, dataObject)

    state.mainText = 'データ再計算中'

    claimChildPromise
      .then(res => {
        const isStatus = apiStatus.statusHandring(res.data.meta)
        if (!isStatus) {
          console.error('APIエラー:' + res.data.meta)
          throw new Error(`APIエラー`)
        }

        // 再計算時に上限管理の管理結果額を初期化する
        state.claimChildParam.dataObject.upperLimit.ubUpperLimitResult = ''

        // 再計算時に様式第二の管理結果を初期化する
        state.claimChildParam.dataObject.details.resultNo = ''

        // 再計算時に様式第二の管理結果額を初期化する
        state.claimChildParam.dataObject.details.resultCost = ''

        state.claimChildParam.dataObject.details.summary = state.claimChildParam.dataObject.details.summary.map(
          (summaryItem: SummaryType) => {
            // 再計算時に様式第二の上限額管理後利用者負担額を初期化
            summaryItem.batAfterUpperLimitCost = ''

            // 再計算時に様式第二の調整後利用者負担額を初期化
            summaryItem.batAfterCost = ''

            // 再計算時に様式第二の利用者負担額②を初期化
            summaryItem.batUbCost = ''

            return summaryItem
          }
        )

        // 再請求側 明細セット
        if (isReBilling) {
          state.claimChildParam.dataObject.details.details =
            res.data.data[0].details.details
        } else {
          // 請求側 明細セット
          state.claimChildParam.dataObject.details.details =
            res.data.data.details
        }

        // 再計算時にサービス利用日数が0の場合は該当サービスのサービス種別欄、給付費明細欄、請求額集計欄を削除する
        deleteBulkServiceAndDetailsAndSummary(
          state.claimChildParam.dataObject.details
        )

        state.mainText = 'データ再計算完了'

        context.root.$store.commit(
          'details/valueSet',
          state.claimChildParam.dataObject.details
        )

        setTimeout(() => {
          state.isChanging = false
        }, 500)
      })
      .catch(err => {
        console.log(err)
        state.mainText = 'データを正常に処理することができませんでした。'
        state.subText =
          '再計算を実施する場合はサービスコード、単位数、回数のいずれかを再度入力し直してください。'

        setTimeout(() => {
          state.isChanging = false
          state.subText = '少々お待ちください。'
        }, 2000)
      })
  }

  const handleSwitchBrotherUpperLimit = () => {
    const res = confirm(
      '現在、入力中の上限管理結果のデータは失われますがよろしいですか？'
    )

    if (!res) return

    // 上限管理をmasterの状態に切り替える
    context.root.$store.commit(
      'upperLimit/valueSet',
      JSON.parse(JSON.stringify(state.claimChildDataByCldId.upperLimit.master))
    )

    // 管理結果額を初期化
    context.root.$store.commit('details/primitiveValueSet', {
      key: 'resultCost',
      value: '',
    })

    state.isBrotherUpperLimit = !state.isBrotherUpperLimit
  }

  const handleCloseCalcErrMsg = () => {
    state.calcErrMsg = ''
  }

  return {
    handlePreSetData,
    existData,
    handleNullToEmptyString,
    handleCalcDetails,
    handleSetBillingUpdateParamVisitChildFlgAndAffiliation,
    handleSwitchBrotherUpperLimit,
    handleCloseCalcErrMsg,
    handleNotBeneficiaryIdUpdateBillingData,
    handlePresetUpperLimitMasterUbData,
    handleBrotherUpperLimitAnotherManagementFlgUpdateBillingData,
    handleResetUpperLimit,
    handlePresetDetailsSummaryItemData,
    handlePresetDetailsSaData,
    handlePresetDetailsSummaryItemDataByCsvReBilling,
  }
}

export const handleResetData = (state: any, context: SetupContext) => {
  const { handleCalcDetails } = useSet(state, context)
  // vuexにストアするdataをmasterに切り替える
  handleErrReset(context)

  if (state.isBrotherUpperLimit) {
    state.isBrotherUpperLimit = false
  }

  context.root.$store.commit(
    'details/valueSet',
    JSON.parse(JSON.stringify(state.claimChildDataByCldId.details.master))
  )

  context.root.$store.commit(
    'upperLimit/valueSet',
    JSON.parse(JSON.stringify(state.claimChildDataByCldId.upperLimit.master))
  )

  context.root.$nextTick(() => {
    setTimeout(() => {
      handleCalcDetails(state.isReBilling)
    }, 500)
  })
}

export const useSummary = <
  T extends {
    tabs: number
    activePageId: string
    claimSummaryDataByofficeId: {
      [key: string]: number | string
    }[]
    resetClaimSummaryDataByofficeId: {
      [key: string]: number | string
    }[]
    officeName: string
    componentTypes: {
      [key: string]: number | string
    }[]
  }
>(
  state: T,
  context: SetupContext
) => {
  const handleSelectSummaryDataSet = (pageId: string, index: number) => {
    const target = state.claimSummaryDataByofficeId.find(
      (data: any) => data.municipalitiesNo === pageId
    )

    state.tabs = index
    state.activePageId = pageId

    context.root.$nextTick(() => {
      context.root.$store.commit('summary/valueSet', target)
    })
  }

  const existData = (arrayLength: number) => {
    if (arrayLength === 0) {
      alert(`請求データが1つもありません。`)
      return
    }
  }

  const handlePrint = () => {
    const prevHtmlTitle = document.title

    const titleArray = [
      '障害児通所給付費・入所給付費等請求書（様式第一）',
      `都道府県番号：${state.activePageId}`,
      // 事業所名
      state.officeName,
    ]
    const titleString = titleArray.join(' | ')
    document.title = titleString

    window.print()

    document.title = prevHtmlTitle
  }

  const handleNullToEmptyString = (data: any) => {
    Object.keys(data).forEach(key => {
      if (
        (data[key] && typeof data[key] === 'object') ||
        Array.isArray(data[key])
      ) {
        return handleNullToEmptyString(data[key])
      } else {
        if (data[key] === null || data[key] === undefined) {
          data[key] = ''
          return true
        } else {
          return true
        }
      }
    })

    return data
  }

  const handleFindErr = (data: any) => {
    const res = Object.keys(data).some(key => {
      if (
        (data[key] && typeof data[key] === 'object') ||
        Array.isArray(data[key])
      ) {
        return handleFindErr(data[key])
      } else {
        if (key !== 'municipalitiesNo' && data[key]) {
          return true
        }
      }
    })

    return res
  }

  const handleCheckDcEmpty = (data: any, errObj: any) => {
    errObj.dc = []
    for (let index = 0; index < data.length; index++) {
      if (
        Object.keys(data[index]).some(
          (key: string) => data[index][key] || data[index][key] === 0
        )
      ) {
        errObj.dc[index] = {}
        if (data[index].classGrantMunicipalAmount === '') {
          errObj.dc[index].classGrantMunicipalAmount = true
        }
      }
    }
    return errObj
  }

  const handleCheckAdEmpty = (data: any, errObj: any) => {
    errObj.ad = []
    for (let index = 0; index < data.length; index++) {
      if (
        Object.keys(data[index]).some(
          (key: string) => data[index][key] || data[index][key] === 0
        )
      ) {
        errObj.ad[index] = {}

        Object.keys(data[index]).forEach((key: string) => {
          if (data[index][key] === '') {
            errObj.ad[index][key] = true
          }
        })
      }
    }
    return errObj
  }

  const handleCheckValidSummary = (data: any) => {
    const errAllArray: any = []

    for (let index = 0; index < data.summary.length; index++) {
      const errObj: any = {}

      errObj.municipalitiesNo = data.summary[index].municipalitiesNo

      // 空文字チェック 障害児通所給付費 - 自治体助成額
      handleCheckDcEmpty(data.summary[index].dc, errObj)

      // 空文字チェック 障害児入所給付費 - 区分
      // 空文字チェック 障害児入所給付費 - 件数
      // 空文字チェック 障害児入所給付費 - 単位数
      // 空文字チェック 障害児入所給付費 - 費用合計
      // 空文字チェック 障害児入所給付費 - 給付費請求額
      // 空文字チェック 障害児入所給付費 - 利用者負担額
      // 空文字チェック 障害児入所給付費 - 自治体助成額
      handleCheckAdEmpty(data.summary[index].ad, errObj)

      // 空文字チェック 特定入所障害児食費等給付費 - 件数
      // 空文字チェック 特定入所障害児食費等給付費 - 費用合計
      // 空文字チェック 特定入所障害児食費等給付費 - 給付費請求額
      // 空文字チェック 特定入所障害児食費等給付費 - 自治体助成額
      errObj.sa = {}

      if (
        Object.keys(data.summary[index].sa).some(
          (key: string) =>
            data.summary[index].sa[key] || data.summary[index].sa[key] === 0
        )
      ) {
        Object.keys(data.summary[index].sa).forEach((key: string) => {
          if (data.summary[index].sa[key] === '') {
            errObj.sa[key] = true
          }
        })
      }

      errAllArray[index] = errObj
    }

    context.root.$store.commit('summaryValid/valueErrSet', errAllArray)

    return handleFindErr(errAllArray)
  }

  const handleShapeAdArray = (data: any) => {
    for (let index = 0; index < data.summary.length; index++) {
      if (data.summary[index].ad && data.summary[index].ad.length !== 0) {
        data.summary[index].ad = data.summary[index].ad.filter(
          (adData: any) =>
            !Object.keys(adData).every((key: string) => adData[key] === '')
        )
      }
    }

    return data
  }

  const handleResetData = (activePageId: string) => {
    // vuexにストアするdataをmasterに切り替える
    const res = window.confirm(
      '現在、入力中のデータは失われますがよろしいですか？'
    )

    if (res) {
      const targetSummary = state.resetClaimSummaryDataByofficeId.find(
        data => data.municipalitiesNo === activePageId
      )

      context.root.$store.commit(
        'summary/valueSet',
        JSON.parse(JSON.stringify(targetSummary))
      )
    }
  }

  const handleSummaryDataButtonCreate = (claimSummaryDataByofficeId: any) => {
    state.componentTypes = claimSummaryDataByofficeId.map((data: any) => {
      return {
        id: data.id,
        pageId: data.municipalitiesNo,
      }
    })
  }

  return {
    handleSelectSummaryDataSet,
    existData,
    handlePrint,
    handleNullToEmptyString,
    handleFindErr,
    handleCheckDcEmpty,
    handleCheckAdEmpty,
    handleCheckValidSummary,
    handleShapeAdArray,
    handleResetData,
    handleSummaryDataButtonCreate,
  }
}

export const handletoCircled = (num: number) => {
  const base = '①'.charCodeAt(0)
  return String.fromCharCode(base + num - 1)
}

type brotherObj = {
  id: string
}

type customCldInfo = cldInfo & {
  brotherArray: brotherObj[]
}

export const handleCreateAllCldBrotherArray = (
  targetCldArray: any[],
  omitTargetCldId = ''
) => {
  if (omitTargetCldId) {
    targetCldArray = targetCldArray.filter(
      (cldInfo: customCldInfo) => cldInfo.id !== omitTargetCldId
    )
  }

  const cldArrayByIsBrotherArray = targetCldArray.filter(
    (cldInfo: customCldInfo) =>
      cldInfo.brotherArray && cldInfo.brotherArray.length !== 0
  )

  const brotherAllArray: string[] = []

  cldArrayByIsBrotherArray.forEach((cldInfo: customCldInfo) => {
    const ownBrotherArray: brotherObj[] = cldInfo.brotherArray.filter(
      (brotherObj: brotherObj) => brotherObj.id
    )

    brotherAllArray.push(
      ...ownBrotherArray.map((brotherObj: brotherObj) => brotherObj.id)
    )
  })

  return brotherAllArray
}

export const useUtilsByUserBurdens = (state: any) => {
  const existData = (arrayLength: number) => {
    if (arrayLength === 0) {
      alert(`請求データが1つもありません。`)
      return
    }
  }

  const handlePrint = () => {
    const prevHtmlTitle = document.title

    const titleArray = [
      '利用者負担額一覧表',
      `（提供先） ${state.offerOffice}`,
      // 事業所名
      state.officeName,
    ]
    const titleString = titleArray.join(' | ')
    document.title = titleString

    window.print()

    document.title = prevHtmlTitle
  }

  return {
    existData,
    handlePrint,
  }
}

export const handleIsReBillingShowAlert = (
  targetYear: string | number,
  targetMonth: string | number
) => {
  let leaveFlg = false

  const isReBillingShowAlertHidden = sessionStorageUtils.handleGetSessionStorage(
    'isReBillingShowAlertHidden'
  )

  const billingTargetDateLine = moment()
    .add(-2, 'months')
    .startOf('month')
    .format('YYYY-MM')

  if (
    !isReBillingShowAlertHidden &&
    moment(`${targetYear}-${targetMonth}`, 'YYYY-MM').isSameOrBefore(
      billingTargetDateLine
    )
  ) {
    const res = confirm(
      `${Number(targetYear)}年${Number(
        targetMonth
      )}月分の再請求を行う場合は「OK」を押して再請求の画面を開きます。\n過去の実績記録の確認などを行う場合は「キャンセル」を押してください。`
    )

    if (res) {
      const rebillingAccess = document.createElement('a')

      localStorageUtils.handleSetLocalStorage('reBellingTargetDate', {
        targetYear: targetYear,
        targetMonth: targetMonth,
      })

      rebillingAccess.setAttribute('href', '/claim_country/re_billing/')
      rebillingAccess.setAttribute('target', '_blank')
      rebillingAccess.click()
      rebillingAccess.remove()

      leaveFlg = true
    }
  }

  if (!leaveFlg) {
    sessionStorageUtils.handleSetSessionStorage(
      'isReBillingShowAlertHidden',
      true
    )
  }

  return leaveFlg
}

export const handleCheckCopyDuplicationByCld = (
  childDataArray: { [key: string]: string | number | string[] | any }[]
) => {
  const copyChildDataArray: {
    [key: string]: string | number | string[]
  }[] = []

  childDataArray.forEach(
    (childInfo: { [key: string]: string | number | string[] | any }) => {
      if (
        childInfo.affiliationAchievement !== null &&
        childInfo.affiliationAchievement !== undefined &&
        typeof childInfo.affiliationAchievement == 'object'
      ) {
        const affiliationAchievementArray = Object.keys(
          childInfo.affiliationAchievement
        ).map((key: string) => childInfo.affiliationAchievement[key])

        const affiliationAchievement = new Set(affiliationAchievementArray)

        const sortAffiliationAchievementArray = Array.from(
          affiliationAchievement
        )

        childInfo.affiliationAchievement = String(
          sortAffiliationAchievementArray[0]
        )

        for (
          let index = 1;
          index < sortAffiliationAchievementArray.length;
          index++
        ) {
          const copyChildData = JSON.parse(JSON.stringify(childInfo))
          copyChildData.affiliationAchievement =
            sortAffiliationAchievementArray[index]
          copyChildDataArray.push(copyChildData)
        }
      }
    }
  )

  childDataArray = Array.prototype.concat(childDataArray, copyChildDataArray)

  return childDataArray
}

export const handleIsDiffDetailsOfChild = (
  targetBillingDetails: DetailsState,
  childInfo: {
    affiliation: string
    visitChildFlg?: string
    visit_child_flg?: string
  }
) => {
  const visitChildFlg = childInfo.visitChildFlg
    ? childInfo.visitChildFlg
    : childInfo.visit_child_flg

  if (targetBillingDetails) {
    if (
      !handleIsDetailsSummaryServiceCodeTypeInTargetAffiliation(
        childInfo.affiliation,
        targetBillingDetails
      )
    ) {
      return true
    }

    if (childInfo.affiliation === '2') {
      if (
        handleIsDetailsSummaryServiceCodeTypeInTargetAffiliation(
          '1',
          targetBillingDetails
        ) ||
        handleIsDetailsSummaryServiceCodeTypeInTargetAffiliation(
          '0',
          targetBillingDetails
        )
      ) {
        return true
      }
    }

    if (
      visitChildFlg === '1' &&
      !handleIsDetailsSummaryServiceCodeTypeInTargetAffiliation(
        '2',
        targetBillingDetails
      )
    ) {
      return true
    }

    if (
      visitChildFlg !== '1' &&
      handleIsDetailsSummaryServiceCodeTypeInTargetAffiliation(
        '2',
        targetBillingDetails
      )
    ) {
      return true
    }
  }

  return false
}

export const handleCheckDeleteByCld = (
  childDataArray: { [key: string]: string | number | string[] | any }[],
  officeNumber: number,
  billingDetailsArray: CustomBillingDetailsType[]
) => {
  childDataArray.forEach(
    (childInfo: { [key: string]: string | number | string[] | any }) => {
      // 実績0件のパターンで給付費明細が作成済み
      if (
        childInfo.isAchievement === '0' &&
        childInfo.isVisitAchievement === '0' &&
        (childInfo.isWaiting === '1' || childInfo.isBenefit === '1')
      ) {
        // 上限管理がない
        if (
          !childInfo.upperLimit ||
          Object.keys(childInfo.upperLimit).length === 0
        ) {
          childInfo.delete = true
        }

        // 上限管理が他社
        if (
          Object.keys(childInfo.upperLimit).length !== 0 &&
          String(childInfo.upperLimit['0'].office_number) !==
            String(officeNumber)
        ) {
          childInfo.delete = true
        }

        const targetBillingDetails = billingDetailsArray.find(
          (billingDetails: CustomBillingDetailsType) =>
            billingDetails.cld_id === childInfo.id
        )

        if (childInfo.delete) {
          childInfo.affiliationDetails = ''
          childInfo.affiliationAchievement = ''
        }
      }
    }
  )

  return childDataArray
}

export const useSummaryValid = () => {
  const handleIsNoBeneficiaryIdCld = (childItemArray: any[]) => {
    let res = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (billingTargetCldArray.some((cld: any) => cld.isNobeneficiaryId)) {
      res = true
    }

    return res
  }

  const handleIsNoBeneficiaryIdCldAndNormalCldMix = (childItemArray: any[]) => {
    let res = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (
      !billingTargetCldArray.every(
        (cld: any) =>
          billingTargetCldArray[0].isNobeneficiaryId === cld.isNobeneficiaryId
      )
    ) {
      res = true
    }

    return res
  }

  const handleIsAllCreatedDetails = (childItemArray: any[]) => {
    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target && cldObj.isOrigin !== '0'
    )

    const isCldBillingAllCreated = billingTargetCldArray.every(
      (cldObj: any) =>
        cldObj.isBenefit === '1' && cldObj.isWaiting !== '1' && !cldObj.delete
    )

    return isCldBillingAllCreated
  }

  const getDuplicateValues = ([...array]) => {
    return array.filter(
      (value, index, self) =>
        self.indexOf(value) === index && self.lastIndexOf(value) !== index
    )
  }

  const handleIsBrotherUpperLimitDupCldDefect = (childItemArray: any[]) => {
    let defect = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    // きょうだい上限管理配列を取得する
    let brotherValueArray = handleCreateAllCldBrotherArray(
      billingTargetCldArray
    )

    brotherValueArray = getDuplicateValues(brotherValueArray)

    if (brotherValueArray && brotherValueArray.length !== 0) {
      defect = true

      billingTargetCldArray.forEach((cldObj: any) => {
        if (
          cldObj.brotherArray &&
          cldObj.brotherArray.some((brotherCld: any) =>
            brotherValueArray.some(
              (brotherDupCld: string) => brotherDupCld === brotherCld.id
            )
          )
        ) {
          cldObj.isBrotherDupCldId = true
        } else {
          cldObj.isBrotherDupCldId = false
        }
      })
    } else {
      billingTargetCldArray.forEach((cldObj: any) => {
        cldObj.isBrotherDupCldId = false
      })
    }

    return defect
  }

  const handleIsDiffAchievementsCldByCldId = (
    childItemArray: any[],
    cldId: string
  ) => {
    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (
      billingTargetCldArray.filter(
        (checkCldObj: any) => checkCldObj.id === cldId
      ).length > 1
    ) {
      return true
    } else {
      return false
    }
  }

  const handleIsDiffAchievementsCld = (childItemArray: any[]) => {
    let defect = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    // 請求対象の児童の中で所属の異なる実績記録が存在する
    billingTargetCldArray.forEach((cldObj: any) => {
      if (
        billingTargetCldArray.filter(
          (checkCldObj: any) => checkCldObj.id === cldObj.id
        ).length > 1
      ) {
        cldObj.duplicate = true
      } else {
        cldObj.duplicate = false
      }
    })

    const isCldAllow = billingTargetCldArray.some(
      (data: { [key: string]: string | number | string[] | any }) =>
        data.duplicate === true
    )

    billingTargetCldArray.forEach((cldObj: any) => {
      cldObj.otherDuplicate = false
    })

    if (isCldAllow) {
      defect = true
    }

    return defect
  }

  const handleIsDeleteCldByCldId = (childItemArray: any[], cldId: string) => {
    const defect = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (
      billingTargetCldArray.some(
        (data: { [key: string]: string | number | string[] | any }) =>
          data.delete === true && data.id === cldId
      )
    ) {
      return true
    } else {
      return false
    }

  }

  const handleIsDeleteCld = (childItemArray: any[]) => {
    let defect = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    const isCldAllow = billingTargetCldArray.some(
      (data: { [key: string]: string | number | string[] | any }) =>
        data.delete === true
    )

    if (isCldAllow) {
      defect = true
    }

    return defect
  }

  const handleIsBrotherUpperLimitCldDefect = (
    childItemArray: BillingCldTableItemInfo[]
  ) => {
    let res = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: BillingCldTableItemInfo) => cldObj.billing_target
    )

    if (
      billingTargetCldArray.some(
        (cld: any) => cld.isBrotherUpperLimitCldDefect
      )
    ) {
      res = true
    }

    return res
  }

  const handleIsCldAllIsReBillingCld = (childItemArray: any[]) => {
    let res = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (billingTargetCldArray.every((cld: any) => cld.reBillingCldId)) {
      res = true
    }

    return res
  }

  const handleIsDupDayAchivementsCld = (childItemArray: any[]) => {
    let res = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (
      billingTargetCldArray.some(
        (cld: any) => cld.isDupDayAchivements || cld.isDupDayVisitAchivements
      )
    ) {
      res = true
    }

    return res
  }

  const handleIsErrCountConsultationAdditionCld = (childItemArray: any[]) => {
    let res = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (
      billingTargetCldArray.some(
        (cld: any) => cld.isErrCountConsultationAddition
      )
    ) {
      res = true
    }

    return res
  }

  const handleIsDiffCldObjAffiliationAndAchievementsAffiliationCld = (
    childItemArray: any[]
  ) => {
    let res = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (
      billingTargetCldArray.some(
        (cld: any) =>
          cld.isDiffCldObjAffiliationAndAchievementsAffiliation ||
          cld.isDiffCldObjAffiliationAndAchievementsAffiliationByVisit
      )
    ) {
      res = true
    }

    return res
  }

  const handleIsDiffCldObjAffiliationAndDetailsAffiliationCld = (
    childItemArray: any[]
  ) => {
    let res = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (billingTargetCldArray.some((cld: any) => cld.isDiffDetailsOfChild)) {
      res = true
    }

    return res
  }

  const handleIsDiffCldObjAffiliationAndOfficeAffiliationCld = (
    childItemArray: any[]
  ) => {
    let res = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (
      billingTargetCldArray.some(
        (cld: any) => cld.isDiffCldObjAffiliationAndOfficeAffiliation
      )
    ) {
      res = true
    }

    return res
  }

  const handleIsNotOriginCld = (childItemArray: any[]) => {
    let res = false

    const billingTargetCldArray = childItemArray.filter(
      (cldObj: any) => cldObj.billing_target
    )

    if (billingTargetCldArray.some((cld: any) => cld.isOrigin !== '1')) {
      res = true
    }

    return res
  }

  const handleIsWaitingUpperLimitOfDetails = (targetDetails: DetailsState) => {
    if (targetDetails.officeNumber && targetDetails.resultNo === '') {
      return true
    } else {
      return false
    }
  }

  return {
    handleIsNoBeneficiaryIdCld,
    handleIsAllCreatedDetails,
    getDuplicateValues,
    handleIsBrotherUpperLimitDupCldDefect,
    handleIsDiffAchievementsCld,
    handleIsDeleteCld,
    handleIsDeleteCldByCldId,
    handleIsBrotherUpperLimitCldDefect,
    handleIsCldAllIsReBillingCld,
    handleIsNoBeneficiaryIdCldAndNormalCldMix,
    handleIsDupDayAchivementsCld,
    handleIsNotOriginCld,
    handleIsErrCountConsultationAdditionCld,
    handleIsDiffCldObjAffiliationAndAchievementsAffiliationCld,
    handleIsDiffCldObjAffiliationAndOfficeAffiliationCld,
    handleIsWaitingUpperLimitOfDetails,
    handleIsDiffAchievementsCldByCldId,
    handleIsDiffCldObjAffiliationAndDetailsAffiliationCld,
  }
}

export const useBillingListViewStyle = () => {
  const getBadge = (status: any) => {
    switch (status) {
      case 0:
        return 'secondary'
      case 1:
        return 'success'
      case 2:
        return 'warning'
      case 3:
        return 'danger'
      default:
        return 'primary'
    }
  }

  const getClaimBenefitBadge = (item: any) => {
    if (item.isDiffDetailsOfChild) {
      return 'danger'
    } else if (item.isWaiting === '1') {
      return 'warning'
    } else if (item.isBenefit === '1' && item.isUpperLimit === '1') {
      return 'success'
    } else if (item.delete) {
      return 'danger'
    } else {
      return 'secondary'
    }
  }

  const getClaimBadge = (status: any) => {
    switch (status) {
      case '1':
        return 'success'
      default:
        return 'secondary'
    }
  }

  const getIsInvoiceBadge = (status: string) => {
    switch (status) {
      case '1':
        return 'success'
      default:
        return 'secondary'
    }
  }

  return {
    getBadge,
    getClaimBadge,
    getClaimBenefitBadge,
    getIsInvoiceBadge,
  }
}

export const handleUpdateCurrentCldInfo = (
  billingArray: any[],
  currentCldArray: any[]
) => {
  billingArray = billingArray.map((cldInfo: any) => {
    const mappingKeyArray = [
      'first_kana',
      'first_name',
      'last_kana',
      'last_name',
      'parents_first_kana_1',
      'parents_first_name_1',
      'parents_last_kana_1',
      'parents_last_name_1',
      'beneficiary_id',
      'office_name',
      'office_number',
    ]

    const targetCldInfo = currentCldArray.find(
      (currentCld: any) => currentCld.id === cldInfo.id
    )

    if (targetCldInfo) {
      mappingKeyArray.forEach((key: string) => {
        cldInfo[key] = targetCldInfo[key]
      })
    }

    return cldInfo
  })

  return billingArray
}

export const handleSetReBillingMode = () => {
  let res = false

  const htmlElement = document.documentElement

  if (location.href.match(/re_billing/)) {
    htmlElement.classList.add('re-billing')

    res = true
  } else {
    htmlElement.classList.remove('re-billing')
  }

  return res
}

export const handleShapeUpdateReBillingOfficeParam = (officeInfo: any) => {
  const customPostOfficeInfo: any = {}
  const customCamelOfficeInfo: any = {}

  const exclusionKeyArray = [
    'billingAreaClass',
    'isCreationCategory',
    'areaClassLevel',
  ]

  Object.keys(officeInfo).forEach((key: string) => {
    const camelKey = format.camelCase(key)

    customCamelOfficeInfo[camelKey] = officeInfo[key]
  })

  Object.keys(customCamelOfficeInfo).forEach((camelKey: string) => {
    if (
      exclusionKeyArray.some(
        (exclusionKey: string) => exclusionKey === camelKey
      )
    ) {
      customPostOfficeInfo[camelKey] = customCamelOfficeInfo[camelKey]
    } else {
      const snakeKey = format.snakeCase(camelKey)

      customPostOfficeInfo[snakeKey] = customCamelOfficeInfo[camelKey]
    }
  })

  return customPostOfficeInfo
}

const exclusionKeyArray = [
  'kasanSpecial',
  'kasanSupport1',
  'kasanSupport2',
  'kasanStrength',
  'parentAgree',
  'kasanDayUpper',
  'parentsPassword',
  'contractDate',
  'contractEndDate',
  'startUsingDate',
  'endUsingDate',
  'ubUpperLimitMonthlyAmount',
  'parentAgreeDate',
  'beneficiaryEntryFieldNo',
  'kasanCare',
  'visitBeneficiaryEntryFieldNo',
  'visitContractDate',
  'visitContractEndDate',
  'visitStartUsingDate',
  'visitEndUsingDate',
  'visitKasanUpperLimit',
]

const specialSnakeKeyArray = [
  'parentsFirstKana1',
  'parentsFirstName1',
  'parentsLastKana1',
  'parentsLastName1',
]

export const handleShapeUpdateReBillingCldParam = (childInfo: any) => {
  const customPostCldInfo: any = {}
  const customCamelCldInfo: any = {}

  Object.keys(childInfo).forEach((key: string) => {
    const camelKey = format.camelCase(key)

    customCamelCldInfo[camelKey] = childInfo[key]
  })

  Object.keys(customCamelCldInfo).forEach((camelKey: string) => {
    if (
      exclusionKeyArray.some(
        (exclusionKey: string) => exclusionKey === camelKey
      )
    ) {
      customPostCldInfo[camelKey] = customCamelCldInfo[camelKey]
    } else if (
      specialSnakeKeyArray.some(
        (exclusionKey: string) => exclusionKey === camelKey
      )
    ) {
      const specialSnakeKey = format.handleSnakeToStrAndNumberCamel(camelKey)

      customPostCldInfo[specialSnakeKey] = customCamelCldInfo[camelKey]
    } else {
      const snakeKey = format.snakeCase(camelKey)

      customPostCldInfo[snakeKey] = customCamelCldInfo[camelKey]
    }
  })

  return customPostCldInfo
}

const primaryCldKeyArray = [
  'active',
  'id',
  'zip',
  'city',
  'block',
  'building',
  'prefecture',
  'firstName',
  'lastName',
  'firstKana',
  'lastKana',
  'parentsFirstName1',
  'parentsLastName1',
  'parentsFirstKana1',
  'parentsLastKana1',
  'contractAmount',
  'paymentAmount',
  'beneficiaryId',
  'cityNumber',
  'startUsingDate',
  'endUsingDate',
  'upperLimit',
  'officeArray',
  'ubUpperLimitMonthlyAmount',
  'beneficiaryEntryFieldNo',
  'contractDate',
  'contractEndDate',
  'affiliation',
  'jihatsuKasanPreschoolersFlg',
  'severeChildFlg',
  'jihatsuKasanSeverelyDisabled',
  'creationCategory',
  'schoolYear',
]

export const handleIsCldReBillingData = (childInfo: any) => {
  const additionAllKeyArray: string[] = []

  childAllAdditionItemArray.forEach(
    (obj: { [key: string]: string | string[] }) => {
      additionAllKeyArray.push(...obj.keyArray)
    }
  )

  primaryCldKeyArray.push(...additionAllKeyArray)

  if (
    primaryCldKeyArray.every(
      (primaryCldKey: string) => primaryCldKey in childInfo
    )
  ) {
    return true
  } else {
    primaryCldKeyArray.forEach((primaryCldKey: string) =>
      !(primaryCldKey in childInfo) && childInfo.type === 'ACHIEVEMENTS_CHILD'
        ? console.error(primaryCldKey)
        : ''
    )

    return false
  }
}

export const handleToZenKata = (str: string) => {
  const D_MUD = 'ガギグゲゴザジズゼゾダヂヅデドバビブベボパピプペポヴヷヺ'
  const S_MUD = 'ｶﾞｷﾞｸﾞｹﾞｺﾞｻﾞｼﾞｽﾞｾﾞｿﾞﾀﾞﾁﾞﾂﾞﾃﾞﾄﾞﾊﾞﾋﾞﾌﾞﾍﾞﾎﾞﾊﾟﾋﾟﾌﾟﾍﾟﾎﾟｳﾞﾜﾞｦﾞ'
  //kiyone
  const D_KIY =
    'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホ' +
    'マミムメモヤユヨラリルレロワヲンァィゥェォッャュョ。、ー「」・'
  const S_KIY = 'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝｧｨｩｪｫｯｬｭｮ｡､ｰ｢｣･'

  for (let i = 0, len = D_MUD.length; i < len; i++) {
    str = str.split(S_MUD.slice(i * 2, i * 2 + 2)).join(D_MUD.slice(i, i + 1))
  }
  for (let i = 0, len = D_KIY.length; i < len; i++) {
    str = str.split(S_KIY.slice(i, i + 1)).join(D_KIY.slice(i, i + 1))
  }
  return str
}

const repaint = async () => {
  for (let i = 0; i < 2; i++) {
    await new Promise(resolve => requestAnimationFrame(resolve))
  }
}

export const handleBulkPrint = async (
  context: SetupContext,
  printTitle: string,
  officeName: string
) => {
  const prevHtmlTitle = document.title

  await repaint()

  context.root.$nextTick(async () => {
    await repaint()

    context.root.$nextTick(() => {
      const titleArray = [
        printTitle,
        // 事業所名
        officeName,
      ]

      const titleString = titleArray.join(' | ')

      document.title = titleString

      window.print()

      document.title = prevHtmlTitle
    })
  })
}

export const useBillingTop = (
  state: {
    officeId: string
    targetYear: number | null | string
    targetMonth: number | null | string
    updateIsAchievementsFlg: boolean
    isShow: boolean
    mainText: string
  },
  handleGetBillingCldStsData: Function
) => {
  // 選択年月の実績記録最新化
  const handleUpdateAchievements = () => {
    const paramYear = ('0000' + state.targetYear).slice(-4)

    const paramMonth = ('00' + state.targetMonth).slice(-2)

    const achievementsPromise = updateAchievementsAndGetTargetCldBookCnt(
      state.officeId,
      {
        year: paramYear,
        month: paramMonth,
      }
    )

    achievementsPromise
      .then(response => {
        console.log(response)
        if (!response) return
        const isStatus = apiStatus.statusHandring(response.data.meta)

        if (!isStatus) {
          alert(
            `データを正常に更新できませんでした。エラーコード[${response.data.meta}]`
          )
          return
        }

        if (
          response.data.data.cldbookRecordCount ||
          response.data.data.cldbookRecordDeleteCount
        ) {
          const [totalTime, totalSec, totalMinutes] = handleGetWaitingTime(
            response.data.data.cldbookRecordCount,
            response.data.data.cldbookRecordDeleteCount
          )

          if (totalMinutes < 5) {
            alert(
              `実績データの更新を開始しました。反映まで${
                totalMinutes ? totalMinutes + '分' : ''
              }${totalSec}秒ほどお待ちいただくか、反映時間経過後にご確認ください。`
            )

            setTimeout(() => {
              state.updateIsAchievementsFlg = false
              state.isShow = false

              state.mainText = 'データを再取得中です。'

              handleGetBillingCldStsData()
            }, totalTime)
          } else {
            alert(
              '件数が多いため、処理完了までに時間がかかります。しばらく時間をおいてからご確認ください。'
            )
          }
        } else {
          state.updateIsAchievementsFlg = false
        }
      })
      .catch(err => {
        console.log(err)
        alert(`データを正常に更新できませんでした。`)
        return
      })
  }

  return {
    handleUpdateAchievements,
  }
}

export const useDetailsShape = () => {
  const handleGetMinPriceOfArray = (
    priceArray: (string | number | undefined | null)[]
  ) => {
    const priceNumberArray = priceArray.filter(
      (price: string | number | undefined | null) =>
        price !== '' && price !== undefined && price !== null
    ) as (string | number)[]

    const checkNumberArray = priceNumberArray.map((price: string | number) =>
      Number(price)
    ) as number[]

    const minPrice = Math.min(...checkNumberArray)

    return minPrice
  }

  const handleGetProratedValue = (
    standardValue: string | number,
    subtractionValue: string | number
  ): number[] => {
    standardValue = Number(standardValue)
    subtractionValue = Number(subtractionValue)

    if (standardValue < 0) {
      alert(
        '正常に計算をすることができませんでした。はじめからやりなおしてください。'
      )
      history.back()
      return []
    }

    if (standardValue === 0) return [0, 0]

    const calculatedStandardValue = standardValue - subtractionValue

    if (calculatedStandardValue >= 0) {
      return [subtractionValue, calculatedStandardValue]
    } else {
      return [standardValue, 0]
    }
  }

  const handleGetSummaryTotalObj = (summaryArray: SummaryType[]) => {
    const summaryTotal: SummaryTotalType = {
      batBeUnitsTotal: 0, //[合計]サービス単位数
      batTotalCostTotal: 0, //[合計]総費用額
      batUpperLimitMontylyAmountTotal: 0, //[合計]上限月額調整
      batAfterCostTotal: '', // [合計]調整後利用負担額
      batAfterUpperLimitCostTotal: '', // [合計]上限額管理後利用者負担額
      batDecisionUbCostTotal: 0, //[合計]決定利用者負担額
      batBillingAmountTotal: 0, //[合計]請求額/給付費
      batBillingGrantMunicipalTotal: 0,
    }

    type SummaryTypeKeyType = keyof SummaryType
    type SummaryTotalKeyType = keyof SummaryTotalType

    const setCheckSummaryKeyArray: SummaryTypeKeyType[] = [
      'batAfterCost',
      'batAfterUpperLimitCost',
      'batBillingGrantMunicipal',
    ]

    for (const setCheckSummaryKey of setCheckSummaryKeyArray) {
      if (
        summaryArray.some(
          (summaryItem: SummaryType) =>
            summaryItem[setCheckSummaryKey] !== '' &&
            summaryItem[setCheckSummaryKey] !== undefined
        )
      ) {
        const setCheckSummaryTotalKey = (setCheckSummaryKey +
          'Total') as SummaryTotalKeyType

        summaryTotal[setCheckSummaryTotalKey] = 0
      }
    }

    for (const summaryItem of summaryArray) {
      // 請求額集計欄[[給付単位数(合計)]]
      if (summaryItem.batBeUnits) {
        summaryTotal.batBeUnitsTotal += Number(summaryItem.batBeUnits)
      }

      // 請求額集計欄[[総費用額(合計)]]
      if (summaryItem.batTotalCost) {
        summaryTotal.batTotalCostTotal += Number(summaryItem.batTotalCost)
      }

      // 請求額集計欄[[上限月額調整(合計)]]
      if (summaryItem.batUpperLimitMontylyAmount) {
        summaryTotal.batUpperLimitMontylyAmountTotal += Number(
          summaryItem.batUpperLimitMontylyAmount
        )
      }

      // 請求額集計欄[[調整後利用負担額(合計)]]
      if (
        summaryItem.batAfterCost &&
        typeof summaryTotal.batAfterCostTotal === 'number'
      ) {
        summaryTotal.batAfterCostTotal += Number(summaryItem.batAfterCost)
      }

      // 請求額集計欄[[上限額管理後利用者負担額(合計)]]
      if (
        summaryItem.batAfterUpperLimitCost &&
        typeof summaryTotal.batAfterUpperLimitCostTotal === 'number'
      ) {
        summaryTotal.batAfterUpperLimitCostTotal += Number(
          summaryItem.batAfterUpperLimitCost
        )
      }

      // 請求額集計欄[[決定利用者負担額(合計)]]
      if (summaryItem.batDecisionUbCost) {
        summaryTotal.batDecisionUbCostTotal += Number(
          summaryItem.batDecisionUbCost
        )
      }

      // 請求額集計欄[[請求額/給付費(合計)]]
      if (summaryItem.batBillingAmount) {
        summaryTotal.batBillingAmountTotal += Number(
          summaryItem.batBillingAmount
        )
      }

      // 請求額集計欄[[自治体助成分請求額(合計)]]
      if (
        summaryItem.batBillingGrantMunicipal &&
        typeof summaryTotal.batBillingGrantMunicipalTotal === 'number'
      ) {
        summaryTotal.batBillingGrantMunicipalTotal += Number(
          summaryItem.batBillingGrantMunicipal
        )
      }
    }

    return summaryTotal
  }

  const handleSortSummaryArray = (summaryArray: SummaryType[]) => {
    const normalSummaryArray = summaryArray.filter(
      summaryItem =>
        summaryItem.batServiceCodeType === '61' ||
        summaryItem.batServiceCodeType === '63'
    )

    const visitSummaryArray = summaryArray.filter(
      summaryItem => summaryItem.batServiceCodeType === '64'
    )

    const sortSummaryArray = ([] as SummaryType[]).concat(
      normalSummaryArray,
      visitSummaryArray
    )

    return sortSummaryArray
  }

  const handleShapeSummaryItemByBatBillingGrantMunicipal = (
    summaryArray: SummaryType[]
  ) => {
    summaryArray = summaryArray.map(summaryItem => {
      summaryItem.batBillingGrantMunicipal = Number(
        summaryItem.batBillingGrantMunicipal
      )

      return summaryItem
    })

    return summaryArray
  }

  const handleShapeDetailsArray = (detailsArray: DetailsItemType[]) => {
    let multiplyNum = 1

    if (detailsArray.length !== 0) {
      multiplyNum = Math.ceil(
        Number(new BigNumber(detailsArray.length).div(12))
      )
    }

    // 給付費明細欄は最大5枚まで（それ以上は切り捨て）
    if (multiplyNum > 5) {
      multiplyNum = 5
    }

    //給付費明細欄最大表示数 12件
    const detailsMax = multiplyNum * 12

    const setDetailsArray: DetailsItemType[] = []

    for (let i = 0; i < detailsMax; i++) {
      if (!detailsArray[i]) {
        setDetailsArray.push({
          beServiceContents: '',
          beServiceCode: '',
          beUnits: '',
          beCount: '',
          beServiceUnits: '',
          beDescription: '',
        })
      } else {
        setDetailsArray.push(detailsArray[i])
      }
    }

    return setDetailsArray
  }

  const handleSetSummaryBatBeUnits = (
    batServiceCodeType: string,
    summaryItem: SummaryType,
    detailsArray: DetailsItemType[]
  ) => {
    // 請求額集計欄[給付単位数]
    // フロントによる計算・「給付費明細欄」の「サービス単位数」の合計値
    // 給付費明細欄のデータと請求額集計欄のサービス種別とサービスコードの先頭2桁が一致するオブジェクトで抽出
    const constFilterArray = detailsArray.filter(
      detailsItem =>
        detailsItem &&
        detailsItem.beServiceCode &&
        String(detailsItem.beServiceCode).slice(0, 2) ===
          String(batServiceCodeType)
    )

    summaryItem.batBeUnits = 0

    constFilterArray.forEach(detailsItem => {
      if (detailsItem.beServiceUnits || detailsItem.beServiceUnits === 0) {
        summaryItem.batBeUnits =
          Number(summaryItem.batBeUnits) + Number(detailsItem.beServiceUnits)
      }
    })

    return summaryItem
  }

  const handleSetSummaryBatTotalCost = (summaryItem: SummaryType) => {
    // 請求額集計欄[総費用額]
    // フロントによる計算・「給付単位数」×「単位数単価」※小数点以下切り捨て
    summaryItem.batTotalCost = 0

    if (
      (summaryItem.batBeUnits || summaryItem.batBeUnits === 0) &&
      (summaryItem.batUnits || summaryItem.batUnits === 0)
    ) {
      summaryItem.batTotalCost = Math.floor(
        Number(
          new BigNumber(summaryItem.batBeUnits).times(summaryItem.batUnits)
        )
      )
    }

    return summaryItem
  }

  const handleSetSummaryBatEquivalentAmount = (summaryItem: SummaryType) => {
    // 計算ロジック 請求額集計欄[１割相当額]
    // フロントによる計算・「総費用額」の1割（×0.1）※小数点以下切り捨て
    summaryItem.batEquivalentAmount = 0

    if (
      summaryItem &&
      (summaryItem.batTotalCost || summaryItem.batTotalCost === 0)
    ) {
      summaryItem.batEquivalentAmount = Math.floor(
        Number(new BigNumber(summaryItem.batTotalCost).times(0.1))
      )
    }

    return summaryItem
  }

  const handleSetSummaryBatUbCost = (
    summaryItem: SummaryType,
    cldInfoByBatUbCostFlg = {
      freeOfCharge: '0',
      manyChildrenNo: '1',
    }
  ) => {
    // 基本的にフロントによる計算・「１割相当額」と同数値として初期値を設定する
    // 利用者負担額②に入力があった場合に「１割相当額」と比較して小さいを設定する
    if (
      (summaryItem && summaryItem.batUbCost === '') ||
      summaryItem.batUbCost === undefined ||
      Number(summaryItem.batUbCost) > Number(summaryItem.batEquivalentAmount)
    ) {
      summaryItem.batUbCost = summaryItem.batEquivalentAmount

      if (
        defineObject.FREE_OF_CHARGE_AND_MANY_CHILD_TARGET_SERVICE_CODE_TYPE_ARRAY.some(
          checkServiceCodeType =>
            checkServiceCodeType === summaryItem.batServiceCodeType
        )
      ) {
        // 無償化対象または多子軽減の第三子は0円
        if (
          cldInfoByBatUbCostFlg.freeOfCharge === '1' ||
          cldInfoByBatUbCostFlg.manyChildrenNo === '3'
        ) {
          summaryItem.batUbCost = 0

          // 多子軽減の第二子は総費用額×0.5割（0.05）
        } else if (cldInfoByBatUbCostFlg.manyChildrenNo === '2') {
          summaryItem.batUbCost = Math.floor(
            Number(new BigNumber(summaryItem.batTotalCost).times(0.05))
          )
        }
      }
    }

    return summaryItem
  }

  // 計算ロジック 請求額集計欄[上限月額調整](①②の内少ない数)
  // フロントによる計算・「利用者負担上限月額①」と「利用者負担額②」の小さい数値の方
  const handleSetSummaryBatUpperLimitMontylyAmount = (
    summaryItem: SummaryType,
    ubUpperLimitMonthlyAmount: string | number
  ) => {
    summaryItem.batUpperLimitMontylyAmount = handleGetMinPriceOfArray([
      ubUpperLimitMonthlyAmount,
      summaryItem.batUbCost,
    ])

    return summaryItem
  }

  // 計算ロジック 請求額集計欄[調整後利用者負担額]（上限月額調整の合計が利用者負担上限月額を超過した場合に算出する）
  // フロントによる計算・各上限月額調整をもとに利用者負担上限月額を按分する
  const handleSetSummaryBatAfterCost = (
    summaryItem: SummaryType,
    calcUbUpperLimitMonthlyAmount: number
  ): [SummaryType, number] => {
    const subtractionBatAfterCost = handleGetMinPriceOfArray([
      summaryItem.batUpperLimitMontylyAmount,
      summaryItem.batAfterCost,
    ])
    ;[
      summaryItem.batAfterCost,
      calcUbUpperLimitMonthlyAmount,
    ] = handleGetProratedValue(
      calcUbUpperLimitMonthlyAmount,
      subtractionBatAfterCost
    )

    return [summaryItem, calcUbUpperLimitMonthlyAmount]
  }

  // [請求額集計欄]上限額管理後利用者負担額 - 1
  // 上限管理が自社、きょうだい上限管理する側は管理結果後利用者負担額に上限月額調整もしくは調整後利用者負担額を小さい方を格納
  const handleSetSummaryBatUpperLimitMontylyAmountOfOwnUpperLimit = (
    summaryItem: SummaryType
  ) => {
    summaryItem.batAfterUpperLimitCost = handleGetMinPriceOfArray([
      summaryItem.batAfterCost,
      summaryItem.batUpperLimitMontylyAmount,
    ])

    return summaryItem
  }

  const handleSetSummaryBatUpperLimitMontylyAmountOfOtherUpperLimit = (
    summaryItem: SummaryType,
    calcResultCost: number
  ): [SummaryType, number] => {
    // 管理結果後利用者負担額に上限月額調整もしくは調整後利用者負担額を小さい方を格納
    const subtractionBatAfterUpperLimitCost = handleGetMinPriceOfArray([
        summaryItem.batAfterCost,
        summaryItem.batUpperLimitMontylyAmount,
        summaryItem.batAfterUpperLimitCost,
      ])

      /* eslint-disable */
    ;[
      summaryItem.batAfterUpperLimitCost,
      calcResultCost,
    ] = handleGetProratedValue(
      calcResultCost,
      subtractionBatAfterUpperLimitCost
    )
    /* eslint-disable */

    return [summaryItem, calcResultCost]
  }

  // [請求額集計欄]上限額管理後利用者負担額 - 1
  const handleSetSummaryBatAfterUpperLimitCost = (
    summaryItem: SummaryType,
    upperLimitUbArray: ubItem[],
    calcResultCost: number | string
  ): [SummaryType, number | string] => {
    // 上限管理が自社、きょうだい上限管理する側
    if (Array.isArray(upperLimitUbArray) && upperLimitUbArray.length > 0) {
      summaryItem = handleSetSummaryBatUpperLimitMontylyAmountOfOwnUpperLimit(
        summaryItem
      )
    } else {
      // 上限管理他社、きょうだい上限管理される側
      summaryItem.batAfterUpperLimitCost = handleGetMinPriceOfArray([
        summaryItem.batAfterCost,
        summaryItem.batUpperLimitMontylyAmount,
        summaryItem.batAfterUpperLimitCost,
        calcResultCost,
      ])

      if (calcResultCost !== '') {
        calcResultCost = Number(calcResultCost)
        ;[
          summaryItem,
          calcResultCost,
        ] = handleSetSummaryBatUpperLimitMontylyAmountOfOtherUpperLimit(
          summaryItem,
          calcResultCost
        )
      }
    }

    return [summaryItem, calcResultCost]
  }

  // 請求額集計欄[決定利用者負担額]
  // 上限額管理後利用者負担額/調整後利用者負担額のうち、いずれかの小さい値
  const handleSetSummaryBatDecisionUbCost = (summaryItem: SummaryType) => {
    summaryItem.batDecisionUbCost = handleGetMinPriceOfArray([
      summaryItem.batAfterCost,
      summaryItem.batUpperLimitMontylyAmount,
      summaryItem.batAfterUpperLimitCost,
    ])

    return summaryItem
  }

  // [請求額集計欄]請求額/給付費
  // フロントによる計算・「総費用額」-「決定利用者負担額」
  const handleSetSummaryBatBillingAmount = (summaryItem: SummaryType) => {
    summaryItem.batBillingAmount = 0

    if (
      ((summaryItem.batTotalCost || summaryItem.batTotalCost === 0) &&
        summaryItem.batDecisionUbCost) ||
      summaryItem.batDecisionUbCost === 0
    ) {
      summaryItem.batBillingAmount =
        Number(summaryItem.batTotalCost) - Number(summaryItem.batDecisionUbCost)
    }

    return summaryItem
  }

  const handleGetCalcSummaryItemAndSummaryTotal = (
    summaryArray: SummaryType[],
    grantMunicipalNo: string = '',
    ubUpperLimitMonthlyAmount: number | string,
    resultCost: number | string,
    detailsArray: DetailsItemType[],
    ubArray: ubItem[],
    detailsUpperLimitOfficeNumber: number | string,
    isBatAfterCostEdit: boolean,
    summaryColumnsMax: number,
    freeOfCharge: string,
    manyChildrenNo: string
  ): {
    summaryArray: SummaryType[]
    summaryTotal: SummaryTotalType
  } => {
    summaryArray = handleSortSummaryArray(summaryArray)

    summaryArray = handleShapeSummaryItemByBatBillingGrantMunicipal(
      summaryArray
    )

    const fixUbUpperLimitMonthlyAmount = ubUpperLimitMonthlyAmount

    let calcUbUpperLimitMonthlyAmount = fixUbUpperLimitMonthlyAmount

    let calcResultCost = resultCost !== '' ? resultCost : ''

    const isUpperLimit = Boolean(detailsUpperLimitOfficeNumber)

    // 請求額集計欄
    for (let index = 0; index < summaryColumnsMax; index++) {
      if (summaryArray[index]) {
        // 計算ロジック [請求額集計欄]給付単位数
        summaryArray[index] = handleSetSummaryBatBeUnits(
          summaryArray[index].batServiceCodeType,
          summaryArray[index],
          detailsArray
        )

        // 計算ロジック [請求額集計欄]総費用額
        summaryArray[index] = handleSetSummaryBatTotalCost(summaryArray[index])

        // 計算ロジック [請求額集計欄]１割相当額
        summaryArray[index] = handleSetSummaryBatEquivalentAmount(
          summaryArray[index]
        )

        // 計算ロジック [請求額集計欄]利用者負担額②
        summaryArray[index] = handleSetSummaryBatUbCost(summaryArray[index], {
          freeOfCharge: freeOfCharge,
          manyChildrenNo: manyChildrenNo,
        })

        // 計算ロジック [請求額集計欄]上限月額調整(①②の内少ない数)
        summaryArray[index] = handleSetSummaryBatUpperLimitMontylyAmount(
          summaryArray[index],
          fixUbUpperLimitMonthlyAmount
        )

        // 計算ロジック [請求額集計欄]調整後利用者負担額
        if (isBatAfterCostEdit) {
          /* eslint-disable */
          ;[
            summaryArray[index],
            calcUbUpperLimitMonthlyAmount,
          ] = handleSetSummaryBatAfterCost(
            summaryArray[index],
            Number(calcUbUpperLimitMonthlyAmount)
          )
          /* eslint-disable */
        } else {
          summaryArray[index].batAfterCost = ''
        }

        // [請求額集計欄]上限額管理後利用者負担額
        if (isUpperLimit) {
          ;[
            summaryArray[index],
            calcResultCost,
          ] = handleSetSummaryBatAfterUpperLimitCost(
            summaryArray[index],
            ubArray,
            calcResultCost
          )
        } else {
          summaryArray[index].batAfterUpperLimitCost = ''
        }

        // [請求額集計欄]決定利用者負担額
        summaryArray[index] = handleSetSummaryBatDecisionUbCost(
          summaryArray[index]
        )

        // [請求額集計欄]請求額/給付費
        summaryArray[index] = handleSetSummaryBatBillingAmount(
          summaryArray[index]
        )
      }
    }

    const summaryTotal = handleGetSummaryTotalObj(summaryArray)

    return {
      summaryArray: summaryArray,
      summaryTotal: summaryTotal,
    }
  }

  const handleGetCalcSummaryItemAndSummaryTotalBridge = (
    state: {
      details: DetailsVuexState
      upperLimit: upperLimitVuexState
    },
    isBatAfterCostEdit: boolean,
    summaryColumnsMax: number
  ) => {
    const {
      summaryArray,
      summaryTotal,
    } = handleGetCalcSummaryItemAndSummaryTotal(
      state.details.data.summary,
      state.details.data.grantMunicipalNo,
      state.details.data.ubUpperLimitMonthlyAmount,
      state.details.data.resultCost,
      state.details.data.details,
      state.upperLimit.data.ub,
      state.details.data.officeNumber,
      isBatAfterCostEdit,
      summaryColumnsMax,
      state.details.data.freeOfCharge,
      state.details.data.manyChildrenNo
    )

    return {
      summaryArray: summaryArray,
      summaryTotal: summaryTotal,
    }
  }

  const handleIsUnderResultCost = (summaryTotal: SummaryTotalType) => {
    const compareCost = handleGetMinPriceOfArray([
      summaryTotal.batAfterCostTotal,
      summaryTotal.batUpperLimitMontylyAmountTotal,
    ])

    if (Number(summaryTotal.batAfterUpperLimitCostTotal) < compareCost) {
      return true
    } else {
      return false
    }
  }

  return {
    handleSetSummaryBatAfterUpperLimitCost,
    handleSetSummaryBatUpperLimitMontylyAmountOfOwnUpperLimit,
    handleSetSummaryBatDecisionUbCost,
    handleSetSummaryBatBillingAmount,
    handleSetSummaryBatAfterCost,
    handleSetSummaryBatUpperLimitMontylyAmount,
    handleSetSummaryBatUbCost,
    handleSetSummaryBatEquivalentAmount,
    handleSetSummaryBatTotalCost,
    handleSetSummaryBatBeUnits,
    handleShapeDetailsArray,
    handleGetSummaryTotalObj,
    handleSortSummaryArray,
    handleShapeSummaryItemByBatBillingGrantMunicipal,
    handleGetCalcSummaryItemAndSummaryTotal,
    handleGetCalcSummaryItemAndSummaryTotalBridge,
    handleIsUnderResultCost,
    handleGetMinPriceOfArray,
    handleGetProratedValue,
  }
}

export const useNewBillingTop = (
  state: {
    officeId: string
    targetYear: number | null | string
    targetMonth: number | null | string
    updateIsAchievementsFlg: boolean
    isShow: boolean
    mainText: string
  },
  handleGetBillingCldStsData: Function
) => {
  // 選択年月の実績記録最新化
  const handleUpdateAchievements = () => {
    const paramYear = ('0000' + state.targetYear).slice(-4)

    const paramMonth = ('00' + state.targetMonth).slice(-2)

    const achievementsPromise = updateNewAchievementsAndGetTargetCldBookCnt(
      state.officeId,
      {
        year: paramYear,
        month: paramMonth,
      }
    )

    achievementsPromise
      .then(response => {
        console.log(response)
        if (!response) return
        const isStatus = apiStatus.statusHandring(response.data.meta)

        if (!isStatus) {
          alert(
            `データを正常に更新できませんでした。エラーコード[${response.data.meta}]`
          )
          return
        }

        if (
          response.data.data.cldbookRecordCount ||
          response.data.data.cldbookRecordDeleteCount
        ) {
          const [totalTime, totalSec, totalMinutes] = handleGetWaitingTime(
            response.data.data.cldbookRecordCount,
            response.data.data.cldbookRecordDeleteCount
          )

          if (totalMinutes < 5) {
            alert(
              `実績データの更新を開始しました。反映まで${
                totalMinutes ? totalMinutes + '分' : ''
              }${totalSec}秒ほどお待ちいただくか、反映時間経過後にご確認ください。`
            )

            setTimeout(() => {
              state.updateIsAchievementsFlg = false
              state.isShow = false

              state.mainText = 'データを再取得中です。'

              handleGetBillingCldStsData()
            }, totalTime)
          } else {
            alert(
              '件数が多いため、処理完了までに時間がかかります。しばらく時間をおいてからご確認ください。'
            )
          }
        } else {
          state.updateIsAchievementsFlg = false
        }
      })
      .catch(err => {
        console.log(err)
        alert(`データを正常に更新できませんでした。`)
        return
      })
  }

  return {
    handleUpdateAchievements,
  }
}

